export default {
    "de": {
        "months": {
            "january": "Januar",
            "february": "Februar",
            "march": "März",
            "april": "April",
            "may": "Mai",
            "june": "Juni",
            "july": "Juli",
            "august": "August",
            "september": "September",
            "october": "Oktober",
            "november": "November",
            "december": "Dezember"
        },
        "passwords": {
            "password": "Passwörter müssen mindestens 6 Zeichen lang sein und korrekt bestätigt werden.",
            "password_secure": "Passwort (Empfehlung: mind. 8 Zeichen, mind. 1 Großbuchstabe, mind. 1 Zahl, mind. 1 Sonderzeichen)",
            "reset": "Das Passwort wurde zurückgesetzt!",
            "sent": "Passworterinnerung wurde gesendet!",
            "token": "Der Passwort-Wiederherstellungs-Schlüssel ist ungültig oder abgelaufen.",
            "user": "Es konnte leider kein Nutzer mit dieser E-Mail Adresse gefunden werden.",
            "not_secure": "Passwort darf <ul><li>KEINE Leerzeichen</li></ul> und muß <ul><li>mind. 8 Zeichen lang</li><li>mind. 1 Großbuchstaben</li><li>mind. 1 Zahl und</li><li>mind. 1 Sonderzeichen</li></ul> enthalten."
        },
        "auth": {
            "failed": "Diese Zugangsdaten wurden nicht in unserer Datenbank gefunden.",
            "throttle": "Zu viele Login Versuche. Versuchen Sie es bitte in {seconds} Sekunden.",
            "denied": "Sie sind nicht berechtigt, diesen Vorgang durchzuführen. Bitte manipulieren Sie nicht die Formulardaten!"
        },
        "frontend": {
            "customers_4": {
                "step_3": "Weitere Informationen",
                "extra_1": "Extra-Feld 1",
                "extra_2": "Extra-Feld 2",
                "extra_3": "Extra-Feld 3"
            },
            "customers": {
                "customer_registration": "Neukundenregistrierung",
                "save": "Registrieren",
                "next_step": "Weiter",
                "step_1": "Persönliche Daten",
                "step_2": "Kontaktinformationen",
                "step_4": "Vertragsbedingungen",
                "back": "zurück",
                "email_confirmation": "E-Mail-Adresse bestätigen",
                "email_marketing_confirmed": "Ja, ich bin damit einverstanden,",
                "classic_marketing_confirmed": "Postalische Mailings erlauben",
                "terms_and_conditions": "Vertrags- und Datenschutzbestimmungen akzeptieren",
                "address_1": "Adresse",
                "street": "Straße",
                "street_number": "Hausnummer"
            }
        },
        "pagination": {
            "previous": "&laquo; zurück",
            "next": "weiter &raquo;"
        },
        "mail": {
            "import": {
                "maintext_success": "Ihr Import wurde erfolgreich beendet.",
                "maintext_fail": "Achtung: Beim Import sind Fehler aufgetreten. Der Import wurde nicht durchgeführt! Überprüfen Sie den Inhalt ihrer Datei entsprechend der folgenden Hinweise:",
                "greeting": "Hallo",
                "processed": "Es wurden insgesamt %s Datensätze verarbeitet.",
                "imported": "Davon wurden %s importiert. Diese teilen sich auf in:",
                "created_and_updated": "%s neue Datensätze und %s aktualisierte Datensätze.",
                "got_errors": "Bei der Verarbeitung sind Fehler aufgetreten, die nachfolgend zusammengefasst werden: ",
                "error": "Fehler",
                "field_incorrect": "Der importierte Wert für das Smart.KIS-Feld %s ist fehlerhaft.",
                "error_times": "Der Fehler trat insgesamt %s mal auf.",
                "first_row": "Erster Datensatz: %s – Meldung: %s - Gegebener Wert: %s – Verarbeitet: %s",
                "last_row": "Letzter Datensatz: %s – Meldung: %s - Gegebener Wert: %s – Verarbeitet: %s",
                "row": "Datensatz: %s – Meldung: %s - Gegebener Wert: %s – Verarbeitet: %s"
            },
            "export_fail": {
                "maintext_fail": "Achtung: Beim Export sind Fehler aufgetreten. Der Export wurde nicht durchgeführt!",
                "greeting": "Hallo",
                "expire_note": "HINWEIS: DOWNLOADLINKS SIND NUR BIS 7 TAGE NACH ERSTELLUNG DES EXPORTS GÜLTIG. SIE MÜSSEN IM SMARTKIS BACKEND EINGELOGGT SEIN UM DIE DATEI ABRUFEN ZU KÖNNEN"
            },
            "export_no_data": {
                "file": "Datei",
                "maintext": "Es wurden keine Kundendaten für einen Export gefunden, die zu Ihrer Anfrage passen.",
                "greeting": "Hallo"
            },
            "export_monitoring": {
                "maintext_success_basic": "Ihr Monitoring-Bericht wurde erfolgreich erstellt.",
                "maintext_success_newfriends": "Ihr Neukundenentwicklung-Bericht wurde erfolgreich erstellt.",
                "maintext_fail": "Achtung: Beim Erstellen des Monitoring-Berichtes sind Fehler aufgetreten. Der Bericht konnte nicht erstellt werden!",
                "greeting": "Hallo",
                "get_report_basic": "Monitoring",
                "view": "einsehen",
                "get_report_newfriends": "Bericht",
                "expire_note": "HINWEIS: SIE MÜSSEN IM SMARTKIS BACKEND EINGELOGGT SEIN UM DEN BERICHT EINSEHEN ZU KÖNNEN"
            },
            "export_success": {
                "file": "Datei",
                "download": "herunterladen",
                "maintext": "Ihr Export wurde erfolgreich beendet. Per Klick auf den Button können Sie auf ihren Export zugreifen",
                "greeting": "Hallo",
                "expire_note": "HINWEIS: DOWNLOADLINKS SIND NUR BIS 7 TAGE NACH ERSTELLUNG DES EXPORTS GÜLTIG. SIE MÜSSEN IM SMARTKIS BACKEND EINGELOGGT SEIN UM DIE DATEI ABRUFEN ZU KÖNNEN"
            },
            "invitation": {
                "maximum_reached": "Die maximale Teilnehmeranzahl von %s für die Kampagne %s wurde erreicht.",
                "link": "Zur Gästeliste",
                "subject_maximum_reached": "Teilnehmerzahl erreicht: "
            }
        },
        "backend": {
            "dsgvo_documentation": {
                "dsgvo_documentation": "DSGVO Dokumentation",
                "create": "Neuen Eintrag erstellen",
                "save": "DSGVO Dockumentation speichern",
                "create_documentation": "DSGVO Dokumentation erstellen",
                "created": "DSGVO Dokumentation erstellt",
                "created_at": "Erstellt am",
                "confirmed_at": "Bestätigt am",
                "comment": "Kommentar",
                "show_details": "Details",
                "ip_address": "IP-Adresse",
                "email_text": "E-Mail Text",
                "right_of_withdrawal_text": "Widerrufsbelehrung",
                "unconfirmed": "Nicht bestätigt",
                "type": "Art",
                "types": {
                    "email_marketing_subscription": "E-Mail-Marketing Zustimmung",
                    "email_marketing_unsubscription": "E-Mail-Marketing Abmeldung"
                }
            },
            "campaign_customers": {
                "campaign_customers": "Kampagnen-Aussendungen",
                "campaign_customer": "Kampagnen-Aussendung",
                "new": "Neue Kampagnen-Aussendung",
                "edit": "Kampagnen-Aussendung bearbeiten",
                "save": "Kampagnen-Aussendung speichern",
                "created": "Kampagnen-Aussendung erstellt",
                "updated": "Kampagnen-Aussendung aktualisiert",
                "deleted": "Kamapgnen-Aussendung gelöscht",
                "current_number": "Lfd.Nr.",
                "is_redeemed": "Eingelöst",
                "value": "Wert",
                "code": "Code",
                "redeemed_at": "Eingelöst am",
                "expires_at": "Verfällt am",
                "embargo_until": "Embargo bis",
                "redeem": "Einlösen",
                "redeem_revert": "Einlösung rückgängig machen",
                "redeem_question": "Aussendung wirklich einlösen?",
                "redeem_revert_question": "Einlösung wirklich rückgängig machen?",
                "redeemed": "Kampagnen-Aussendung eingelöst",
                "redeem_reverted": "Einlösung der Kampagnen-Aussendung rückgängig gemacht",
                "allcampaignsforcustomers": "alle Kampagnen anzeigen (letzte 36 Monate)",
                "actualcampaignsforcustomers": "laufende Kampagnen anzeigen",
                "creation_failed": "Die Aussendung in der Zeile %s konnte nicht erstellt werden. Bitte prüfen Sie, ob die Kampagne bzw. Push-Nachricht existiert.",
                "import": {
                    "import": "Kampagnen-Aussendungen importieren",
                    "value_type": "Wert Typ",
                    "file": "Importdatei",
                    "format_incorrect": "Ungültiges Importformat",
                    "wrong_campaign": "Falsche Kampagnen ID {campaign_id} in Zeile {row}",
                    "no_customer": "Ungültige Kundennummer {customer_identifier} in Zeile {row}",
                    "created": "Kampagnen-Aussendung für {customer_identifier} wurde erstellt",
                    "updated": "Kampagnen-Aussendung für {customer_identifier} wurde aktualisiert",
                    "import_data_too_old": "Zu importierende Daten für Kunde {customer_identifier} sind älter als die vorliegenden Daten (Zeile {row})",
                    "success": "Ihre %saussendungen wurden erfolgreich importiert.",
                    "failed": "Beim Import Ihrer %saussendungen ist ein unbekannter Fehler aufgetreten.",
                    "there_is_log": "Es gibt Fehler oder Warnungen beim Import: "
                }
            },
            "employees": {
                "employees": "Verkaufspersonal",
                "employee": "Verkaufspersonal",
                "new": "Neues Verkaufspersonal",
                "edit": "Verkaufspersonal bearbeiten",
                "save": "Verkaufspersonal speichern",
                "created": "Verkaufspersonal erstellt",
                "updated": "Verkaufspersonal aktualisiert",
                "deleted": "Verkaufspersonal gelöscht",
                "external_identifier": "Externe Identifikations-Nummer (z.B. aus Warenwirtschaft)",
                "external_identifier_short": "Nummer",
                "import": {
                    "format_incorrect": "Ungültiges Importformat",
                    "created": "Verkaufspersonal {external_identifier} wurde erstellt",
                    "updated": "Verkaufspersonal {external_identifier} wurde aktualisiert"
                }
            },
            "campaigns": {
                "id": "Kampagnen ID",
                "campaigns": "Kampagnen",
                "campaign": "Kampagne",
                "campaign_control": "Kampagnensteuerung",
                "version_old": "Alt",
                "version_new": "Neu (3.0)",
                "new": "Neue Kampagne",
                "edit": "Kampagne bearbeiten",
                "save": "Kampagne speichern",
                "created": "Kampagne erstellt",
                "updated": "Kampagne aktualisiert",
                "deleted": "Kamapgne gelöscht",
                "type": "Typ",
                "name_internal": "Interner Name",
                "headline": "Headline",
                "subline": "Subline",
                "value": "Wert",
                "minimum_value": "Mindesteinkauf",
                "percentage_value": "Rabatt (Prozent)",
                "product_group_1_to_exclude": "Hauptwarengruppen ausschließen - Durch Semikolon getrennt",
                "product_group_2_to_exclude": "Unterwarengruppen ausschließen - Durch Semikolon getrennt",
                "store": "Ort",
                "description_1": "Freitext",
                "description_2": "Freitext 2",
                "description_3": "Freitext 3",
                "description_4": "Freitext 4",
                "description_5": "Freitext 5",
                "validity": "Anzeige für Gültigkeit/Termin in der APP",
                "teaser_image": "Bild für Listenansicht",
                "body_image": "Bild für Detailansicht",
                "date_type": "Laufzeit",
                "date_types": {
                    "multiple_days": "Mehrere Tage (Start- und Enddatum)",
                    "single_day": "Ein Tag (Aktionsdatum)",
                    "0": ""
                },
                "types": {
                    "bonus_voucher": "Bonusscheck",
                    "coupon_euro": "Gutschein mit Wert (beliebige Währung)",
                    "coupon_percent": "Gutschein mit Prozentwert",
                    "give_away": "Give-Away",
                    "invitation": "Einladung",
                    "coupon_backwards": "Rückwärtsgutschein"
                },
                "code_types": {
                    "no_code": "Kein Code",
                    "static_code": "Statischer Code",
                    "static_code_with_image": "Statischer Code mit QR- oder Barcode-Bild",
                    "individual_code_with_image": "Individueller Code mit QR- oder Barcode-Bild"
                },
                "code_type": "Code-Typ",
                "code": "Statischer Code",
                "multiple_redeem": "Kann mehrfach eingelöst werden (bis zum Ablaufdatum)",
                "can_be_redeemed": "Teilnahme kann bestätigt werden (nur relevant für Einladungen)",
                "maximum_participants": "Maximale Teilnehmerzahl (Freilassen für unbegrenzte Teilnehmerzahl)",
                "email": "E-Mailadresse für Info bei Erreichen der Teilnehmerzahl - Getrennt durch Strichpunkt (;)",
                "custom_option_key": "Freie Aufzählung (Name)",
                "custom_option_value": "Freie Aufzählung (Inhalt)",
                "link": "Verlinkung",
                "google_analytics_campaign_code": "Google Analytics Kampagnen-Code",
                "starts_at": "Startdatum",
                "ends_at": "Enddatum",
                "created_at": "erstellt am",
                "is_at": "Aktionsdatum",
                "monitoring_starts_at": "Auswertungsstart (Monitoring)",
                "monitoring_ends_at": "Auswertungsende (Monitoring)",
                "show_until": "In der App anzeigen bis (14 Tage, falls leer)",
                "campaign_info": "Kampagneninformationen (Anzeige in der App)",
                "code_info": "Angaben zum Barcode/QR Code",
                "image_info": "Bilder",
                "additional_info": "Weitere Informationen",
                "embargo_until": "Embargo bis",
                "registration_offer_valid_for": "Aussendung nach Registrierung gültig für (Tage)",
                "registration_offer_valid_until_end_date": "Aussendung ist bis zum Kampagnenende gültig",
                "add_on_registration": "Bei Registrierung Aussendung erstellen",
                "has_variable_description": "Kundenspezifischer Beschreibungstext",
                "campaign_settings_info": "Weitere Kampagneneinstellungen",
                "all_languages": "Für alle Sprachen",
                "upload_file": "CSV-Datei hochladen",
                "backwards_coupon_info": "Bei einem Rückwärtsgutschein wird als Wert eine Ganz- oder Kommazahl erwartet. Weitere Zeichen sind ungültig. In der App wird der Wert in € dargestellt.",
                "backwards_coupon_warning": "Bei Rückwärtsgutscheinen darf als Wert nur eine Zahl mit einem Punkt oder Komma als Dezimaltrenner angegeben werden!",
                "with_start_and_end_date": "Kampagne mit Start - und Enddatum(nicht kombinierbar)",
                "with_fixed_date": "Kampagne mit fixem Datum(nicht kombinierbar)",
                "campaign_validity_info": "Laufzeit der Kampagne",
                "expiration_info": "Anzeige und Verfallsdatum",
                "registration_offer": "Aussendung bei Registrierung über die App",
                "active": "Für Kunden sichtbar",
                "inactive": "Nicht für Kunden sichtbar",
                "has_campaign_customers": "Hat Aussendungen",
                "does_not_have_campaign_customers": "Hat keine Aussendungen"
            },
            "holidaysvacations": {
                "holidaysvacations": "Ferien und Feiertage",
                "holidaysvacation": "Ferien oder Feiertag",
                "new": "Neue Ferien oder Feiertrag",
                "edit": "Ferien oder Feiertag bearbeiten",
                "save": "Ferien oder Feiertag speichern",
                "created": "Ferien oder Feiertag erstellt",
                "updated": "Ferien oder Feiertag aktualisiert",
                "deleted": "Ferien oder Feiertag gelöscht",
                "starts_at": "Start",
                "ends_at": "Ende",
                "type": "Art",
                "types": {
                    "holiday": "Feiertag",
                    "vacation": "Ferien"
                },
                "state": "Bundesland",
                "states": {
                    "BW": "Baden-Württemberg",
                    "BY": "Bayern",
                    "BE": "Berlin",
                    "BB": "Brandenburg",
                    "HB": "Bremen",
                    "HH": "Hamburg",
                    "HE": "Hessen",
                    "MV": "Mecklenburg-Vorpommern",
                    "NI": "Niedersachsen",
                    "NW": "Nordrhein-Westfalen",
                    "RP": "Rheinland-Pfalz",
                    "SL": "Saarland",
                    "SN": "Sachsen",
                    "ST": "Sachsen-Anhalt",
                    "SH": "Schleswig-Holstein",
                    "TH": "Thueringen"
                }
            },
            "chats": {
                "chats": "Chats"
            },
            "smartkis": {
                "smartkis": "smart.KIS"
            },
            "qr_campaigns": {
                "qr_campaigns": "QR Kampagnen",
                "qr_campaign": "QR Kampagne",
                "new": "Neue QR Kampagne",
                "edit": "QR Kampagne bearbeiten",
                "save": "QR Kampagne speichern",
                "created": "QR Kampagne erstellt",
                "updated": "QR Kampagne aktualisiert",
                "deleted": "QR Kamapgne gelöscht",
                "name": "Name",
                "type": "Typ",
                "customer_can_have_multiple_items": "Kunde kann mehrmals einlösen (nur relevant für Roulette)",
                "spinner_text": "Text beim Einlösen innerhalb der App",
                "failure_text": "Text beim Fehlschlagen innerhalb der App",
                "navigation_item_active_from": "Navigationspunkt \"QR Code scannen\" aktivieren ab",
                "navigation_item_active_until": "Navigationspunkt \"QR Code scannen\" abschalten ab",
                "starts_at": "QR Kampagne startet am",
                "ends_at": "QR Kampagne endet am",
                "types": {
                    "normal": "Normal",
                    "roulette": "Roulette"
                },
                "app_visibility_info": "Sichtbarkeit des Navigationspunktes",
                "validity_info": "Gültigkeit der QR Kampagne",
                "item": "Element",
                "is_redeemed": "Benutzt",
                "redeem": "Code sperren",
                "redeemed": "Code gesperrt",
                "redeen_reverted": "Code freigegeben",
                "redeem_revert": "Code wieder freigeben",
                "redeem_question": "Code wirklich sperren?",
                "redeem_revert_question": "Code wirklich freigeben?",
                "code": "Code",
                "show_code": "Code anzeigen",
                "show_roulette_code": "Roulette code",
                "item_info": "Elemente",
                "show_codes": "Codes anzeigen",
                "codes_for_campaign": "Codes für QR Kampangne \"{name}\"",
                "number_of_codes": "Anzahl Codes",
                "success_text": "Text bei Einlösung",
                "add_item": "Element hinzufügen",
                "items": "Elemente",
                "text_only": "-- Keine Kampagne - nur Textanzeige (z.B. für \"Nieten\") --",
                "disabled": "Codes für diese QR Kampagne wurden bereits generiert - es können keine Veränderungen an den Elementen mehr vorgenommen werden!",
                "generate_codes": "Codes generieren",
                "download_codes": "Codes herunterladen",
                "code_confirmation_question": "Nach dem Generieren können keine Änderungen an den Elementen mehr vorgenommen werden! Wollen Sie wirklich die Codes generieren?",
                "codes_generated": "{number_of_codes} Codes wurden generiert",
                "codes_not_generated": "Codes konnten nicht generiert werden, da bereits Codes für diese QR Kampagne vorhanden sind"
            },
            "campaign_notifications": {
                "id": "Push-Nachrichten ID",
                "campaign_notifications": "Push-Nachrichten",
                "campaign_notification": "Push-Nachricht",
                "new": "Neue Push-Nachricht",
                "edit": "Push-Nachricht bearbeiten",
                "save": "Push-Nachricht speichern",
                "created": "Push-Nachricht erstellt",
                "updated": "Push-Nachricht aktualisiert",
                "deleted": "Push-Nachricht gelöscht",
                "current_number": "Lfd.Nr.",
                "type": "Typ",
                "types": {
                    "generic": "Allgemeine Push-Nachricht (ohne Kampagne)",
                    "all": "Für alle Kampagnen-Aussendungen",
                    "reminder-all": "Reminder (für ALLE Aussendungen)",
                    "reminder-redeemed": "Reminder (für Aussendungen, die BEREITS EINGELÖST/BESTÄTIGT worden sind)",
                    "reminder-not-redeemed": "Reminder (für Aussendungen, die NICHT EINGELÖST/BESTÄTIGT worden sind)",
                    "registration": "Für neue Registrierungen",
                    "sale-single": "Einkauf bewerten (einzeln)",
                    "sale-multiple": "Einkäufe bewerten (mehrere)",
                    "refund-single": "Umtausch bewerten (einzeln)",
                    "refund-multiple": "Umtausch bewerten (mehrere)",
                    "sale-refund-mixed": "Besuch bewerten (Einkauf / Umtausch gemischt)",
                    "birthday": "Geburtstag",
                    "news": "News"
                },
                "news_id": "News-ID (aus Wordpress)",
                "embargo_until": "Embargo bis",
                "valid_for": "Aussendung nach Registrierung gültig für (Tage)",
                "text": "Text der Push Notification",
                "delay_for": "Push Notification verzögern (Minuten)"
            },
            "transactions": {
                "transactions": "Bewegungsdaten",
                "transaction": "Bewegungsdatensatz",
                "new": "Neuer Bewegungsdatensatz",
                "edit": "Bewegungsdatensatz bearbeiten",
                "save": "Bewegungsdatensatz speichern",
                "created": "Bewegungsdatensatz erstellt",
                "updated": "Bewegungsdatensatz aktualisiert",
                "deleted": "Bewegungsdatensatz gelöscht",
                "types": {
                    "sale": "Verkauf",
                    "refund": "Retoure",
                    "selection": "Auswahl"
                },
                "wiped": "Bewegungsdatensätze gelöscht",
                "receipt_number": "Kassenbon",
                "has_been_rated": "Bewertung abgegeben",
                "sold_at": "Verkaufsdatum",
                "type": "Art der Bewegung",
                "store": "Filiale (aus dem Import)",
                "department": "Abteilung",
                "cash_register": "Kassennummer",
                "seller": "Verkaufspersonal (aus dem Import)",
                "sku": "Artikelnummer",
                "name": "Name",
                "name_supplemental": "Name (weiter)",
                "quantity": "Menge",
                "supplier": "Lieferant",
                "label": "Label",
                "product_group_1": "Hauptwarengruppe",
                "product_group_2": "Unterwarengruppe",
                "size": "Größe",
                "goods_received_at": "Wareneingang am",
                "vat_percentage": "Mehrwertsteuersatz",
                "cost_price": "Einkaufspreis",
                "cost_price_with_vat": "Einkaufspreis (inkl. MwSt.)",
                "sales_price_1": "Verkaufspreis 1",
                "sales_price_1_with_vat": "Verkaufspreis 1 (inkl. MwSt.)",
                "sales_price_2": "Verkaufspreis 2",
                "sales_price_2_with_vat": "Verkaufspreis 2 (inkl. MwSt.)",
                "discount_price": "Rabatt",
                "discount_price_with_vat": "Rabatt (inkl. MwSt.)",
                "reduction_price": "Nachlass",
                "reduction_price_with_vat": "Nachlass (inkl. MwSt.)",
                "article_info": "Artikelinformationen",
                "price_info": "Preisinformationen",
                "receipt_push_sent": "Push-Nachricht zur Bewertung verschickt",
                "import": {
                    "import": "Bewegungsdaten importieren",
                    "file": "Importdatei",
                    "format_incorrect": "Ungültiges Importformat",
                    "created": "Bewegungsdatensatz wurde erstellt",
                    "updated": "Bewegungsdatensatz wurde aktualisiert",
                    "missing_casual_customer": "Es existiert kein Kundendatensatz für einen Laufkunden! Legen Sie zunächst einen Laufkundendatensatz an, bevor Sie den Bewegungsdatenimport starten!",
                    "employee_not_found": "Verkaufspersonal mit der externen Identifikationsnummer {employee_identifier} existiert nicht.",
                    "customer_not_found": "Kunde mit der externen Identifikationsnummer {customer_identifier} existiert nicht. Kassenbon {receipt_number} wird nicht importiert.",
                    "no_customer": "Dem Kassenbon {receipt_number} ist keine Kundennummer zugeordnet. Kassenbon {receipt_number} wird nicht importiert.",
                    "unknown_error": "Es ist ein nicht dokumentierter Fehler aufgetreten."
                },
                "export": {
                    "export": "Bewegungsdaten exportieren",
                    "type": "Typ",
                    "types": {
                        "csv": "CSV",
                        "xls": "Excel"
                    },
                    "header": "Spaltenüberschriften",
                    "headers": {
                        "translated": "Übersetzt",
                        "plain": "Original (Namen der Datenbankfelder)"
                    },
                    "timeframe": "Zeitraum (Maximal 60 Tage)",
                    "from": "Startdatum",
                    "until": "Enddatum",
                    "100klimit": "Bitte beachten Sie, dass eine Datei maximal 100.000 Einträge enthält. Mehrere Dateien werden in einem ZIP-Archiv zum Download angeboten.",
                    "unknown_error": "Es ist ein unbekannter Fehler aufgetreten!",
                    "since": "Seit",
                    "exporters": {
                        "standard-transaction-export": "Standard Bewegungsdaten Exporter 1.0"
                    },
                    "timeframe_too_large": "Der gewählte Zeitraum ist zu groß: maximal 60 Tage!",
                    "timeframe_invalid": "Das Startdatum muss vor dem Enddatum liegen oder diesem entsprechen!",
                    "no_transactions": "Es wurden für diesen Zeitraum und Mandanten keine Bewegungsdaten gefunden",
                    "success": "Der Export wurde erfolgreich gestartet. Sie erhalten eine E-Mail sobald der Export beendet ist."
                },
                "wipe": {
                    "title": "Bewegungsdaten löschen",
                    "all": "Alle Bewegungsdaten löschen",
                    "timeframe": "Bewegungsdaten mit Verkaufsdatum in diesem Zeitraum löschen",
                    "timeframe_sure": "Sind Sie sich sicher, dass Sie alle Bewegungsdaten für * im Zeitraum vom * bis zum * löschen wollen? Diese Aktion wird dokumentiert und kann nicht mehr rückgängig gemacht werden!",
                    "all_sure": "Sind Sie sich sicher, dass Sie alle Bewegungsdaten für * löschen wollen? Diese Aktion wird dokumentiert und kann nicht mehr rückgängig gemacht werden!",
                    "error": "Es ist ein Fehler beim Löschen der Bewegungsdaten aufgetreten. Es wurde nichts gelöscht.",
                    "success": "Die ausgewählten Bewegungsdaten werden nun im Hintergrund gelöscht, sie erhalten eine E-Mail an %s, sobald der Vorgang abgeschlossen ist.",
                    "please_fill": "Bitte wählen Sie gültige Start- und Enddaten.",
                    "subject": "Bewegungsdaten-Löschung bei ",
                    "success_mail": "Ihr Löschauftrag wurde erfolgreich abgeschlossen.",
                    "query": "Auftrag: Durch den User %s mit der ID %s wurde die Löschung von Bewegungsdaten beim Mandanten %s mit der ID %s im Zeitraum vom %s bis zum %s beantragt.",
                    "failed_mail": "Ihr Löschauftrag ist fehlgeschlagen"
                }
            },
            "dashboard": {
                "last_updated": "Letzte Aktualisierung der Statistik",
                "app_registrations": "App-Registrierungen",
                "push_release": "Push-Freigaben",
                "mail_addresses": "E-Mail Adressen",
                "casual_customer": "Laufkundennummer",
                "test_users": "Test-Nutzer",
                "last_customer": "Letzte Stammdatenaktualisierung",
                "last_transaction": "Letzte Bewegungsdatenaktualisierung",
                "not_loaded_yet": "Noch nicht berechnet",
                "calculation_running": "Aktualisiert gerade"
            },
            "apps": {
                "apps": "Apps",
                "app": "App",
                "new": "Neue App",
                "edit": "App bearbeiten",
                "save": "App speichern",
                "created": "App erstellt",
                "updated": "App aktualisiert",
                "deleted": "App gelöscht",
                "name": "Name",
                "opt_in_email_template": "E-Mail Template für Opt-In",
                "password_forgotten_email_template": "E-Mail Template für Passwortanfrage",
                "contact_email_template": "E-Mail Template für das Kontaktformular",
                "personal_shopping_email_template": "E-Mail Template für Personal-Shopping",
                "invitation_email_template": "E-Mail Template für Teilnahmebestätigungen",
                "push_notification_server": "Push-Nachrichten-Server Informationen",
                "push_notification_server_app_id": "OneSignal App ID",
                "push_notification_server_api_key": "REST API KEY aus OneSignal",
                "app_store_info": "App Store Informationen",
                "apple_app_id": "Apple App Store ID",
                "android_app_id": "Google Play App ID",
                "app_logo": "App Logo",
                "developer_mode": "Entwicklermodus aktiv",
                "send_receipt_push": "Push-Nachrichten bei Einkauf/Umtausch verschicken",
                "send_birthday_push": "Push-Nachricht am Geburtstag verschicken",
                "send_birthday_push_options": "Optionen für Geburtstags-Push",
                "sale_in_last_12_months": "Umsatz in den letzten 12 Monaten gemacht",
                "apple_app_identifier": "Apple App Identifier",
                "transaction_code_type": "QR-Code / Barcode für Anzeige der Quittungsnummern",
                "images_info": "Bilder in der App",
                "menu_image": "Bild: Menü",
                "features_image": "Bild: Kundenkartenvorteile",
                "personal_shopping_image": "Bild: Personal Shopping",
                "smtp_info": "SMTP Server Einstellungen",
                "smtp_server": "Server",
                "smtp_port": "Port",
                "smtp_security": "Sicherheit",
                "smtp_user": "Benutzer",
                "smtp_password": "Passwort",
                "smtp_security_options": {
                    "none": "Keine",
                    "tls": "SSL/TLS",
                    "ssl": "SSL"
                },
                "app_version": "App-Version",
                "has_news": "News",
                "has_coupons": "Gutscheine",
                "has_vouchers": "Bonus-Schecks",
                "has_invitations": "Einladungen",
                "has_personal_shopping": "Personal Shopping",
                "has_purchases": "Einkäufe",
                "transactions_visible_months": "Einkäufe in der App sichtbar (Monate, frei lassen für alle)",
                "has_email_confirmation_during_registration": "E-Mail Bestätigung bei Neukundenregistrierung",
                "has_personal_data_change": "Persönliche Daten vom Kunden änderbar",
                "show_share_links": "Zeige 'Share'-Optionen",
                "show_vat_in_purchases": "MwSt. anzeigen",
                "google_maps_api_key": "Google Maps API Key",
                "google_analytics_api_key": "Google Analytics API Key",
                "onesignal_ios_api_key": "OneSignal IOS Key = OneSignal App ID",
                "onesignal_android_api_key": "Google Sender ID",
                "firebase_config": "Firebase Konfiguration",
                "ios_rating_url": "iTunes App Store Bewertungs-URL",
                "android_rating_url": "Google Play Store Bewertungs-URL",
                "purchases_rating_url": "Bewertungsportal für Einkäufe",
                "news_api_url": "News API-URL",
                "news_api_type": "News-Typ",
                "navigation": "Navigation",
                "links": "Links",
                "menu_links": "Menü-Links",
                "link": "Link",
                "link_type": "Art des Links",
                "imprint": "Impressum",
                "terms_and_conditions": "Nutzungsbedingungen",
                "navigation_name": "Name",
                "navigation_icon": "Icon",
                "homepage": "App Startseite",
                "open_menu": "Menü beim Start der App öffnen",
                "country_list": "Liste der erlaubten Länder für die Neukundenregistrierung",
                "feature_info": "Funktionen",
                "news_info": "News",
                "purchase_info": "Einkäufe",
                "api_info": "Externe Schnittstellen",
                "navigation_info": "Navigationspunkte",
                "link_info": "Verlinkungen",
                "text_info": "Texte",
                "country_info": "Ländereinstellungen",
                "text_advantages": "Text \"Kundenkartenvorteile\"",
                "text_personal_shopping": "Text \"Personal Shopping\"",
                "text_qr_scanner": "Text \"QR Scanner\"",
                "text_slider_1": "Text \"Slider #1\"",
                "text_slider_2": "Text \"Slider #2\"",
                "text_slider_3": "Text \"Slider #3\"",
                "slider_image_1": "Bild \"Slider #1\"",
                "slider_image_2": "Bild \"Slider #2\"",
                "slider_image_3": "Bild \"Slider #3\"",
                "qr_scanner_image": "Bild \"QR Scanner\"",
                "client_logo": "Kundenlogo",
                "add_link": "Link hinzufügen",
                "add_navigation": "Navigationspunkt hinzufügen",
                "css_class": "CSS-Klasse",
                "css_classes": {
                    "light": "Hell",
                    "dark": "Dunkel"
                },
                "purchases_configuration": {
                    "add": "Neuen Wert einfügen",
                    "description": "Konfiguration des Kassenbons",
                    "name": "Feld",
                    "css_class": "Style",
                    "strong": "Fett",
                    "strong_and_break": "Fett + Umbruch nach dem Feld",
                    "small": "Klein",
                    "small_and_break": "Klein + Umbruch nach dem Feld",
                    "break": "Umbruch nach dem Feld"
                },
                "update_warning": "Update-Information zu App 3.0",
                "update_warning_text": "Text zur Update-Information",
                "update_warning_active": "Update-Information anzeigen",
                "update_warning_blocking": "Update soll erzwungen werden",
                "save_changes": "Änderungen übernehmen",
                "save_and_quit": "App speichern und schließen",
                "date_of_birth_required": "Geburtsdatum ist Pflichtfeld",
                "mobile_required": "Mobiltelefon ist Pflichtfeld",
                "phone_required": "Telefon ist Pflichtfeld",
                "minimum_age_for_date_of_birth": "Mindesalter bei Registrierung",
                "fb_api_key": "Firebase API Schlüssel",
                "fb_auth_domain": "Firebase Auth Domain",
                "fb_database_url": "Firebase Datenbank URL",
                "fb_project_id": "Firebase Projekt ID",
                "fb_storage_bucket": "Firebase Storagebucket",
                "fb_app_id": "Firebase App ID",
                "fb_measurement_id": "Firebase Measurment ID",
                "fb_messaging_sender_id": "Firebase Messaging Sender ID",
                "news_limit": "Anzahl Newsbeiträge in App",
                "version_appstore": "Versionsnummer Appstore",
                "version_playstore": "Versionsnummer Playstore",
                "version_appflow": "Versionsnummer Appflow"
            },
            "message_templates": {
                "message_templates": "Chatvorlagen",
                "new": "Erstelle Chatvorlage",
                "edit": "Editiere Chatvorlage",
                "save": "Speichere Chatvorlage",
                "created": "Chatvorlage wurde erstellt",
                "updated": "Chatvorlage wurde aktualisiert",
                "deleted": "Chatvorlage wurde gelöscht",
                "textlabel": "Vorlagentext",
                "titlelabel": "Vorlagentitel"
            },
            "stores": {
                "stores": "Filialen",
                "store": "Filiale",
                "new": "Neue Filiale",
                "edit": "Filiale bearbeiten",
                "save": "Filiale speichern",
                "created": "Filiale erstellt",
                "updated": "Filiale aktualisiert",
                "deleted": "Filiale gelöscht",
                "external_identifier": "Externe Identifikations-Nummer (z.B. aus Warenwirtschaft)",
                "geo_coordinates": "Geokoordinaten",
                "opening_times": "Öffnungszeiten",
                "opening_times_1": "Öffnungszeiten #1",
                "opening_times_2": "Öffnungszeiten #2",
                "opening_times_3": "Öffnungszeiten #3"
            },
            "guestlists": {
                "guestlists": "Gästelisten",
                "guestlist": "Gästeliste",
                "redeem": "Einladung bestätigen",
                "redeem_revert": "Einladung rückgängig machen",
                "redeem_question": "Einladung wirklich bestätigen?",
                "redeem_revert_question": "Einladung wirklich rückgängig machen?",
                "redeemed": "Einladung bestätigt",
                "redeem_reverted": "Einladungsbestätigung rückgängig gemacht",
                "export": {
                    "export": "Gästeliste exportieren",
                    "type": "Typ",
                    "types": {
                        "csv": "CSV",
                        "xls": "Excel"
                    }
                }
            },
            "importer": {
                "format": "Format",
                "types": {
                    "basic": "Standard (CSV)",
                    "excel": "Excel (XSLX)",
                    "csv-utf8": ".csv-Datei (UTF8-Kodiert)"
                },
                "importer_version": "Importer Version",
                "system": "KIS",
                "systems": {
                    "intersport": "Intersport(XLSX)"
                },
                "importers": {
                    "standard-customer-csv-import-v3": "Standard Stammdaten Importer 3.0",
                    "standard-transaction-csv-import-v3": "Standard Bewegungsdaten Importer 3.0",
                    "standard-customer-csv-import-v2": "Standard Stammdaten Importer 2.0",
                    "standard-transaction-csv-import-v2": "Standard Bewegungsdaten Importer 2.0",
                    "hiltes-transaction-csv-import-v2": "Hiltes Bewegungsdaten Importer 2.0"
                },
                "format_incorrect": "Ungültiges Importformat. Die Spalten aus der Importdatei entsprechen nicht den geforderten.",
                "import_successful": "Import erfolgreich. Neue Datensätze: {created}, aktualisierte Datensätze: {updated}",
                "general": {
                    "store_not_found": "Die Filiale mit der externen Identifikationsnummer {store_identifier} existiert nicht."
                },
                "encoding_incorrect": "Die ausgewählte Datei hat ein falsches Encoding. Es werden für einen Import nur UTF-8 kompatible Dateien unterstützt!",
                "column_names_not_unique": "Die Spaltennamen müssen für eine korrekte Zuordnung eindeutig sein! Folgende Spaltennamen sind Duplikate: ",
                "column_names_empty": "Die Spaltennamen dürfen nicht leer und müssen eindeutig sein! Folgende Spalten haben einen leeren Namen: ",
                "create_new_mapping": "Neues Mapping erstellen",
                "mapping_not_found": "Das angegebene Mapping wurde nicht gefunden. Wenn sie sich sicher sind, dass es sich um einen Fehler handelt, wenden Sie sich bitte an den Support.",
                "customer_mapping": "Kunden-Mappings",
                "transaction_mapping": "Bewegungsdaten-Mappings",
                "mapping": "Mapping",
                "not_imported": "Achtung: Beim Import sind Fehler aufgetreten, er wurde nicht durchgeführt: "
            },
            "monitoring_groups": {
                "monitoring_groups": "Kundengruppen",
                "monitoring_group": "Kundengruppe",
                "new": "Neue Kundengruppe",
                "edit": "Kundengruppe bearbeiten",
                "save": "Kundengruppe speichern",
                "created": "Kundengruppe erstellt",
                "updated": "Kundengruppe aktualisiert",
                "deleted": "Kundengruppe gelöscht",
                "name": "Name",
                "minimum_value": "Umsatz >=",
                "maximum_value": "Umsatz <",
                "color": "Farbe",
                "number_groups": "Nummernkreise (z.B. 1-99,201-299)",
                "number_groups_without_brackets": "Nummernkreise",
                "exclude_from_all_friends": "Von allen Kundengruppenberechnungen inkl. \"All Friends\" ausnehmen",
                "expand": "Übersicht anzeigen",
                "new_friends": "New Friends",
                "all_friends": "All Friends",
                "casual_customers": "Laufkunden",
                "note_validity": "Die Kundengruppen werden für den Berater-Assistenten sowie das smart.Monitoring herangezogen. Das Anlegen, Ändern oder Löschen wirkt sich somit auf beide Bereiche aus.",
                "add_new_customers": "Neukundennummernkreise abfragen",
                "new_customers_calculating": "Abfrage läuft, bitte warten...",
                "new_customers_failed": "Die Abfrage ist fehlgeschlagen, bitte versuchen Sie es später erneut."
            },
            "bonus_vouchers": {
                "bonus_vouchers": "Bonus-Schecks",
                "bonus_voucher": "Bonus-Scheck",
                "action_identifier": "Aktionskennung",
                "bonus_identifier": "Bonusfolge",
                "bonus_amount": "Bonusbetrag",
                "import": {
                    "import": "Bonus-Scheck-Aussendungen importieren",
                    "file": "Importdatei",
                    "format_incorrect": "Ungültiges Importformat",
                    "wrong_campaign": "Falsche Kampagnen ID {campaign_id} in Zeile {row}",
                    "no_customer": "Ungültige Kundennummer {customer_identifier} in Zeile {row}",
                    "created": "Bonus-Scheck-Aussendung für {customer_identifier} wurde erstellt",
                    "updated": "Bonus-Scheck-Aussendung für {customer_identifier} wurde aktualisiert",
                    "import_data_too_old": "Zu importierende Daten für Kunde {customer_identifier} sind älter als die vorliegenden Daten (Zeile {row})"
                }
            },
            "devices": {
                "devices": "Geräte / Push Freigabe",
                "device": "Gerät / Push Freigabe",
                "new": "Neues Gerät / Push Freigabe",
                "edit": "Gerät / Push Freigabe bearbeiten",
                "save": "Gerät / Push Freigabe speichern",
                "created": "Gerät / Push Freigabe erstellt",
                "updated": "Gerät / Push Freigabe aktualisiert",
                "deleted": "Gerät / Push Freigabe gelöscht",
                "player_id": "Player-ID",
                "platform": "Plattform",
                "os": "OS",
                "no_device": "Kein Gerät mit Push Notification",
                "api_version": "API Version",
                "api_versions": {
                    "1": "v1",
                    "2": "v2",
                    "3": "v3",
                    "4": "v4"
                }
            },
            "consultants": {
                "consultants": "Berater",
                "consultant": "Berater",
                "new": "Neuer Berater",
                "edit": "Berater bearbeiten",
                "save": "Berater speichern",
                "created": "Berater erstellt",
                "updated": "Berater aktualisiert",
                "deleted": "Berater gelöscht",
                "position": "Position",
                "store_name_override": "Alternativer Name für Filiale in der App",
                "store_name_override_tooltip": "Hier können Sie einen Namen angeben, der statt dem Filialnamen in der App bei diesem Berater angezeigt wird. Insofern Sie das Feld leerlassen, wird der normale Filialname angezeigt."
            },
            "comments": {
                "comment": "Kommentar",
                "comments": "Kommentare",
                "new": "neuen Kommentar anlegen",
                "edit": "ändern",
                "form": {
                    "title": "Überschrift",
                    "body": "Inhalt"
                },
                "grid": {
                    "title": "Betreff",
                    "body": "Kommentar",
                    "user": "erfasst durch"
                },
                "buttons": {
                    "new": "neuen Kommentar anlegen",
                    "save": "speichern"
                }
            },
            "sync_dashboard": {
                "title": "Synchronisations-Dashboard",
                "overview": "Datenübersicht",
                "total": "Umsatz",
                "revenue": "Rohertrag",
                "reduction": "Rabatte & Nachlässe",
                "cost": "Einkaufspreis",
                "last_updated": "Zuletzt aktualisiert: ",
                "update": "Jetzt aktualisieren",
                "restart_job": "Verküpften Job neustarten",
                "change_date": "Änderungsdatum",
                "messages": "System-Meldungen",
                "update_info": "Eine Aktualisierung kann nur alle 15 Minuten gestartet werden!",
                "update_okay": "Die Daten werden nun aktualisiert",
                "not_supported": "Ihr Browser unterstützt keine dynamischen Grafiken.",
                "close": "Schließen",
                "execute": "Ausführen",
                "last_execution": "Daten zur letzten Ausführung:",
                "last_execution_data": {
                    "date": "Startzeit: ",
                    "type": "Typ: ",
                    "params": "Parameter: "
                },
                "is_active": "Schnittstelle ist momentan aktiv",
                "execution_type": "Ausführungstyp: ",
                "execution_types": {
                    "changed": "Geändert seit: ",
                    "timeframe": "Im Zeitraum: "
                },
                "files_exists": "Datei für Ausführung existiert",
                "units": {
                    "day": "Tage",
                    "week": "Wochen",
                    "month": "Monate",
                    "year": "Jahre"
                },
                "date_no_colon": "Datum",
                "date_info": "Bei der Auswertung in Wochen wird als Startwoche die Kalenderwoche des ausgewählten Tages geladen.",
                "units_count": "Anzahl: ",
                "table_view_collapse": "Tabellenansicht ein/ausklappen",
                "date": "Datum: ",
                "unit": "Zeiteinheit: ",
                "customers": "Stammkunden",
                "casual_customers": "Laufkunden",
                "update_chart": "Grafik aktualisieren",
                "loading": "Daten werden geladen. Bitte warten.",
                "weekdays": {
                    "Mon": "Mo",
                    "Tue": "Di",
                    "Wed": "Mi",
                    "Thu": "Do",
                    "Fri": "Fr",
                    "Sat": "Sa",
                    "Sun": "So"
                },
                "error_messages": {
                    "500": "Es ist ein unbehandelter Fehler aufgetreten"
                },
                "message_attributes": {
                    "message": "Nachricht",
                    "url": "URL",
                    "payload": "Payload"
                },
                "no_user": "Kein Benutzer",
                "channels": {
                    "import": "Import",
                    "export": "Export",
                    "misc": "Allgemein",
                    "app": "App"
                },
                "interface_messages": {
                    "could_not_start": "Die Schnittstelle konnte nicht gestartet werden.",
                    "started": "Die Schnittstelle wurde gestartet.",
                    "seven_days_maximum": "Schnittstellen können mit einem Änderungsdatum nur maximal sieben Tage rückwirkend gestartet werden!",
                    "invalid_date_config": "Das Startdatum muss vor dem Enddatum liegen oder diesem entsprechen!",
                    "end_date_too_late": "Das Enddatum darf nicht später als der heutige Tag sein",
                    "change_date_too_early": "Das Änderungsdatum muss vor dem heutigen Tag liegen oder dieser sein."
                }
            },
            "assistant": {
                "assistant": "Sales.Assist",
                "assistants": "Berater",
                "assign_assistants": "Berater zuordnen",
                "customers": "Kundenübersicht",
                "assistant_tool": "Berater-Tool",
                "removed_successfully": "Berater erfolgreich entfernt",
                "added_successfully": "Berater erfolgreich hinzugefügt",
                "grid": {
                    "assistant": "Berater",
                    "manage_assistants": "Berater verwalten",
                    "created_from": "erfasst von",
                    "created_at": "erfasst am"
                },
                "monitoring": {
                    "header": "Monitoring",
                    "headline": {
                        "sales_value": "Umsatz",
                        "period_of_time": "Zeitraum",
                        "purchases": "Einkäufe",
                        "customer_group": "Kundengruppe",
                        "bon": "Bon",
                        "day": "Tag",
                        "sales_revenue": "Rohertrag (brutto/netto)",
                        "sales_revenue_margin": "Spanne (brutto/netto)",
                        "deviation": "Abweichung zum direkten Vorjahr"
                    }
                },
                "form": {
                    "edit": "Berater ändern",
                    "create": "neuer Berater",
                    "updated_successfully": "Berater wurde erfolgreich aktualisiert",
                    "created_successfully": "Berater wurde erfolgreich aktualisiert",
                    "deleted_successfully": "Berater wurde erfolgreich gelöscht"
                },
                "button": {
                    "create_new_assistent": "neuen Berater anlegen",
                    "assign_assistant": "Berater zuordnen",
                    "reassign_assistant": "Berater entfernen",
                    "show_comments": "Kontaktkommentare anzeigen",
                    "change": "ändern",
                    "start_calc": "Berechnung starten"
                },
                "charts": {
                    "show_chart_sales_values": "Chart Umsätze anzeigen",
                    "sales_value": "Umsatz"
                },
                "comment": {
                    "types": {
                        "in_app": "In-App",
                        "push": "Push",
                        "email": "E-Mail",
                        "whatsapp": "WhatsApp",
                        "phone": "Telefonat",
                        "conversation": "persönliches Gespräch",
                        "chat": "Chat"
                    },
                    "messages": {
                        "updated": "Kommentar wurde erfolgreich geändert",
                        "created": "Kommentar wurde erfolgreich angelegt",
                        "deleted": "Kommentar wurde gelöscht"
                    }
                }
            },
            "selection_results": {
                "selection_results": "Selektionsergebnisse",
                "selection_result": "Selektionsergebnis",
                "new": "Neues Selektionsergebnis",
                "edit": "Selektionsergebnis bearbeiten",
                "save": "Selektionsergebnis speichern",
                "created": "Selektionsergebnis erstellt",
                "updated": "Selektionsergebnis aktualisiert",
                "deleted": "Selektionsergebnis gelöscht",
                "name": "Name",
                "assign_notification": "Ergebnis der Push-Nachrichten-Aussendung für \"{notification}\"",
                "assign_campaign": "Ergebnis der Kampagnen-Aussendung für \"{campaign}\"",
                "assign_campaign_and_notification": "Ergebnis der Kampagnen-Aussendung für \"{campaign}\" und Push-Nachricht \"{notification}\"",
                "really_send_notification": "Push-Nachrichten-Aussendungen werden erstellt. Fortfahren?",
                "really_send_campaign": "Kampagnen-Aussendungen werden erstellt. Fortfahren?",
                "selection_result_from_date": "Selektionsergebnisse von {date}",
                "export_selection_results": "Selektionsergebnisse exportieren",
                "assign_selection_results": "Selektionsergebnisse anwenden",
                "create_campaign_customers": "Kampagnen-Aussendungen erstellen",
                "create_notification_customers": "Push-Nachrichen-Aussendungen erstellen",
                "parameters": "Stammdatenabfragen",
                "views": "Bewegungsdatenabfragen",
                "date_interval": "Zeitintervall",
                "channel": "Kanal",
                "channels": "Kanäle",
                "results": "Anzahl",
                "no_results": "Die gewünschte Selektion beinhaltet keine Kunden!",
                "channel_names": {
                    "all": "Alle",
                    "app": "App",
                    "push": "Push",
                    "email": "E-Mail",
                    "classic": "Post"
                }
            },
            "v3_campaign_notifications": {
                "name": "Nachrichtenname",
                "id": "Nachrichten ID",
                "campaign_notifications": "Nachrichten",
                "auto_campaign_notifications": "Auto-Nachrichten",
                "campaign_notification": "Nachricht",
                "campaign_notification_v3": "Nachricht (Kampagnensteuerung 3.0)",
                "new": "Neue Nachricht",
                "edit": "Nachricht bearbeiten",
                "save": "Nachricht speichern",
                "created": "Nachricht erstellt",
                "updated": "Nachricht aktualisiert",
                "deleted": "Nachricht gelöscht",
                "current_number": "Lfd.Nr.",
                "image": "Bild (Nur für Chat-Nachricht)",
                "channels": {
                    "channel": "Kanal",
                    "channels": {
                        "push": "Push-Nachricht",
                        "chat": "Chat-Nachricht",
                        "push_and_chat": "Push- und Chat-Nachricht"
                    }
                },
                "type": "Typ",
                "types": {
                    "generic": "Allgemeine Nachricht (ohne Kampagne)",
                    "all": "Für alle Kampagnen-Aussendungen",
                    "reminder-all": "Reminder (für ALLE Aussendungen)",
                    "reminder-redeemed": "Reminder (für Aussendungen, die BEREITS EINGELÖST/BESTÄTIGT worden sind)",
                    "reminder-not-redeemed": "Reminder (für Aussendungen, die NICHT EINGELÖST/BESTÄTIGT worden sind)",
                    "news": "News"
                },
                "auto_types": {
                    "all": "Für alle Kampagnen-Aussendungen",
                    "reminder-all": "Reminder (für ALLE Aussendungen)",
                    "reminder-redeemed": "Reminder (für Aussendungen, die BEREITS EINGELÖST/BESTÄTIGT worden sind)",
                    "reminder-not-redeemed": "Reminder (für Aussendungen, die NICHT EINGELÖST/BESTÄTIGT worden sind)",
                    "impulse": "Implus-gesteuert",
                    "external": "Fremdsteuerung",
                    "rhythm": "Rhythmus-gesteuert"
                },
                "types_reduced": {
                    "all": "Für alle Kampagnen-Aussendungen",
                    "reminder-all": "Reminder (für ALLE Aussendungen)",
                    "reminder-redeemed": "Reminder (für Aussendungen, die BEREITS EINGELÖST/BESTÄTIGT worden sind)",
                    "reminder-not-redeemed": "Reminder (für Aussendungen, die NICHT EINGELÖST/BESTÄTIGT worden sind)"
                },
                "news_id": "News-ID (aus Wordpress)",
                "embargo_until": "Versandzeitpunkt",
                "valid_for": "Aussendung nach Registrierung gültig für (Tage)",
                "text": "Text der Nachricht",
                "delay_for": "Verzögern um",
                "variable_info": "Sie erhalten Variablenvorschläge mit der @-Taste. Variablen aus der Aussendung werden nur beim Typ \"Für alle Kampagnen-Aussendungen\" und Remindern ersetzt. Variablen aus einer Datei werden beim Hochladen der Adressdatei ersetzt, wenn Sie bspw. eine zusätzliche Spalte mit den Namen \"bonus\" hochladen, wird auch die Variable @bonus ersetzt.",
                "variable_info_campaign": "Sie erhalten Variablenvorschläge mit der @-Taste."
            },
            "monitoring": {
                "campaigns": {
                    "selected_campaigns": "Selektierte Kampagnen",
                    "headers": {
                        "campaign": "Kampagne",
                        "evaluated_period_of_time": "ausgewerteter Zeitraum",
                        "selected_customers": "selektierte Kunden",
                        "redeemed": "eingelöst",
                        "quote": "Quote",
                        "active_customers": "aktive Kunden"
                    }
                }
            },
            "logviewer": {
                "title": "Logs",
                "select_folder": "Ordner wählen",
                "select_logfile": "Logdatei wählen",
                "error": "Ein unerwarteter Fehler ist aufgetreten"
            },
            "client_profiles": {
                "project_info": "Projektinformationen",
                "client_number": "Händlernummer",
                "code_type_customer": "Art der generierten Codes für die Kundenkarte",
                "code_type_campaign": "Art der generierten Codes für die Kampagnen",
                "code_types": {
                    "qr": "QR Code",
                    "interleave25": "Interleave 2/5",
                    "ean13": "EAN 13",
                    "code128": "Code 128"
                },
                "firestore_api_credentials": "Firestore API Zugangsdaten",
                "firestore_token": "Firestore Token",
                "frontend_name": "Name für Anzeige beim Endkunden (Einkaufsbewertung, etc.)",
                "debtor_number": "Debitorennummer",
                "api_token": "API Token",
                "registration": "Neukundenregistrierung",
                "loyalty_program_name": "Name des Loyalty-Programs",
                "registration_terms_and_conditions_link": "Externe Verlinkung zu den Vertragsbestimmungen",
                "registration_data_security_link": "Externe Verlinkung zu den Datenschutzbestimmungen",
                "has_paper_registration": "Papier",
                "has_digital_registration": "Digital",
                "has_street_number": "Hausnummer als separates feld in den Kundenstammdaten",
                "digital_registrations_are_live": "Über LIVE Schnittstelle (Minimal verfügbare Menge wird ignoriert)",
                "minimum_paper_registrations": "Minimal verfügbare Menge an freien Kundennummern für Papier",
                "minimum_digital_registrations": "Minimal verfügbare Menge an freien Kundennummern für Digital",
                "app_registration_email_template": "E-Mail Template für das Registrierung in der App (nur für digitale Registrierung)",
                "pos_registration_email_template": "E-Mail Template für das Registrierung am POS (nur für digitale Registrierung)",
                "landing_page_info": "Informationen zur Landing-Page",
                "footer": "Landingpage Footer (für Links)",
                "header_navigation": "Navigationselemente (Kopfzeile)",
                "header_navigation_name": "Name",
                "social_media_links": "Social Media Links (Fußzeile)",
                "social_media_links_link": "Link",
                "social_media_links_type": "Typ",
                "add_social_media_link": "Social-Media Link hinzufügen",
                "add_header_navigation": "Navigationselement hinzufügen",
                "customer_registration_store_id_check": "Filiale bei der Registrierung abfragen",
                "customer_registration_has_date_of_birth_text": "Text bei der Abfrage des Geburtsdatums anzeigen",
                "customer_registration_date_of_birth_text": "Text für die Abfrage des Geburtsdatums",
                "customer_registration_info": "Informationstext Startseite",
                "customer_registration_contract_info": "Informationstext Vertragsbedingungen",
                "customer_registration_email_marketing_info": "Informationstext E-Mail Marketing",
                "customer_registration_contract_text": "Vertragsbedingungen",
                "customer_registration_data_security_text": "Datenschutzhinweise",
                "customer_identifier_definition": "Kundennummer-Feld für die Darstellung",
                "kis_type": "Benutztes KIS",
                "kis_types": {
                    "none": "Keine Angabe",
                    "intersys": "InterSYS",
                    "prohandel": "ProHandel",
                    "futura": "Futura",
                    "hiltes": "Hiltes",
                    "intelligix": "Intelligix",
                    "advarics": "Advarics",
                    "irics": "IRICS",
                    "fee": "FEE"
                },
                "import_failure_notification": {
                    "title": "Benachrichtigung bei Importausfall",
                    "mails": "E-Mail(s) für Benachrichtigung",
                    "days": "Nach Tagen des letzten Imports",
                    "active": "Aktiv",
                    "subject": "Betreff",
                    "message": "Nachricht",
                    "mailTooltip": "E-Mails mit Komma oder Leertaste trennen",
                    "messageTooltip": "@tage = Nach Tagen des letzten Imports",
                    "subject_text": "Bitte prüfen Sie den Datenaustausch!",
                    "message_text": "\nSehr geehrter smartKIS Nutzer,<br><br>\n\ndies ist eine automatisierte Nachricht. \nUnser smartKIS hat festgestellt, dass seit @tage Tag(en), kein Datenaustausch der Kaufdaten oder \nStammdaten zwischen Ihrem System und unserem smartKis mehr stattgefunden hat. <br><br>\n\nBitte prüfen Sie umgehend an was dies liegen könnte. Mögliche Ursachen könnten sein:<br>\n\n<ul>\n    <li>Ihr Server ist nicht erreichbar oder abgeschaltet </li>\n    <li> Der automatisierte Export von Dateien aus Ihrem System erfolgt nicht mehr</li>\n    <li> Ihre Schnittstelle ist nicht erreichbar</li>\n</ul>\n\nIm Regelfall importieren wir die Daten automatisiert mit einer Überlappung von 7 Tagen. \nWenn der Datenaustausch länger unterbrochen werden sollte muss ein manueller Import von uns angestoßen werden der \nkostenpflichtigen Aufwand verursacht. Um dies zu vermeiden erhalten Sie diese automatisierte Nachricht.<br><br>\n\nViele Grüße<br><br>\n\nHutter & Unger Support Team",
                    "days_mention": "tage"
                },
                "currency_iso_4217": "Währung"
            },
            "monitoring_archives": {
                "monitoring_archives": "Monitoring-Archivierungen",
                "monitoring_archive": "Monitoring-Archivierung",
                "edit": "Monitoring-Archivierung bearbeiten",
                "save": "Monitoring-Archivierung speichern",
                "created": "Monitoring-Archivierung erstellt",
                "updated": "Monitoring-Archivierung aktualisiert",
                "deleted": "Monitoring-Archivierung gelöscht",
                "name": "Name",
                "type": "Typ",
                "types": {
                    "basic/basic": "Normal",
                    "basic/comparison_years": "Jahresvergleiche",
                    "basic/comparison_stores": "Filialvergleiche",
                    "basic/campaigns": "Kampagnen",
                    "new_friends/basic": "Neukundenentwicklung",
                    "basic/comparison_nationality": "Ländervergleiche"
                },
                "comparison_years": {
                    "1": "Ein Jahr rückwirkend",
                    "2": "Zwei Jahre rückwirkend",
                    "3": "Drei Jahre rückwirkend"
                },
                "starts_at": "Start der Auswertung",
                "ends_at": "Ende der Auswertung",
                "options": "Optionen",
                "monitoring_result_from_date": "Monitoring von {date}"
            },
            "campaign_customer_notifications": {
                "campaign_customer_notifications": "Push-Nachrichten-Aussendungen",
                "campaign_customer_notification": "Push-Nachricht-Aussendung",
                "new": "Neue Push-Nachrichten-Aussendung",
                "edit": "Push-Nachrichten-Aussendung bearbeiten",
                "save": "Push-Nachrichten-Aussendung speichern",
                "created": "Push-Nachrichten-Aussendung erstellt",
                "updated": "Push-Nachrichten-Aussendung aktualisiert",
                "deleted": "Push-Nachrichten-Aussendung gelöscht",
                "is_sent": "Push-Nachricht verschickt",
                "sent_at": "Am",
                "push_notification_id": "Push-Nachrichten-ID (vom PNS)",
                "push_notification_error": "Push-Nachrichten-Response/Fehler (vom PNS)",
                "embargo_until": "Push-Nachrichten-Embargo bis",
                "allnotificationsforcustomers": "alle Push-Aussendungen anzeigen (letzte 36 Monate)",
                "import": {
                    "import": "Push-Nachrichten-Aussendungen importieren",
                    "file": "Importdatei",
                    "format_incorrect": "Ungültiges Importformat",
                    "wrong_campaign_notification": "Falsche Push-Nachrichten ID {campaign_notification_id} in Zeile {row}",
                    "no_customer": "Ungültige Kundennummer {customer_identifier} in Zeile {row}",
                    "customer_does_not_use_app": "Kein App-Benutzer {customer_identifier} in Zeile {row}",
                    "created": "Push-Nachrichten-Aussendung für {customer_identifier} wurde erstellt",
                    "updated": "Push-Nachrichten-Aussendung für {customer_identifier} wurde aktualisiert",
                    "import_data_too_old": "Zu importierende Daten für Kunde {customer_identifier} sind älter als die vorliegenden Daten (Zeile {row})",
                    "campaign_customer_missing": "Es existiert keine Kampagnen-Aussendung für die Kundennummer {customer_identifier}"
                }
            },
            "users": {
                "save": "Speichern",
                "save_and_mail": "Speichern und Aktivierungsmail versenden",
                "send_mail": "Es wird nun eine Aktivierungsmail an %s versandt.",
                "activate_info": "über den nachfolgenden Link können Sie sich durch die Vergabe eines persönlichen Passworts im Hutter & Unger smart.KIS aktivieren. Der Link für die Aktivierung ist drei Tage (72 Stunden) lang gültig.",
                "activate": "Jetzt aktivieren",
                "activation": "Aktivierung Ihres Benutzerkontos im Backend",
                "set_password": "Bitte vergeben Sie ein Passwort für Ihr Benutzerkonto mit der E-Mailadresse <b>%s</b>.",
                "requirements": "Es muss mindestens 10 Zeichen lang sein, Groß-, Kleinschreibung und mindestens eine Zahl und mindestens ein Sonderzeichen beinhalten.",
                "password_errors": {
                    "password_not_okay": "Das Passwort erfüllt die Anforderungen nicht:",
                    "password_ten": "Mindestens 10 Zeichen.",
                    "password_uppercase": "Mindestens 1 Großbuchstabe",
                    "password_lowercase": "Mindestens 1 Kleinbuchstabe",
                    "password_number": "Mindestens 1 Zahl",
                    "password_special": "Mindestens 1 Sonderzeichen",
                    "passwords_the_same": "Das Passwort und die Passwortwiederholung stimmen überein",
                    "invalid_auth": "Der Aktivierungslink ist nicht mehr gültig, es wurde bereits ein Passwort vergeben oder ein neuer Link versandt.",
                    "timeout": "Der Aktivierungslink ist abgelaufen."
                },
                "contact": "Bitte kontaktieren Sie den Support direkt, falls Sie einen neuen Link anfordern möchten: ",
                "href": "mailto:support@hutter-unger.de?subject=Backend-Aktivierungslink",
                "check_email": "Achten Sie bitte darauf, dass es eindeutig ist, für welche E-Mailadresse Sie einen neuen Aktivierungslink anfordern möchten. Senden Sie bitte, insofern möglich, die Anfrage von dieser E-Mailadresse aus.",
                "activation_failed": "Aktivierung im Backend fehlgeschlagen",
                "activation_success": "Ihre Aktivierung war erfolgreich. Sie können sich nun mit dem gewählten Passwort im Backend unter smartkis.hutter-unger.de anmelden.",
                "continue": "Zur Login-Seite",
                "login_as_user": "Als Benutzer anmelden",
                "successfully_logged_in_as_user": "Angemeldet als "
            },
            "exporter": {
                "exporter_version": "Exporter Version",
                "hiltes_deprecation": "Bitte beachten Sie, dass wir im Laufe des Jahres 2021 den Hiltes Exporter entfernen werden. Verwenden Sie daher bitte schon jetzt den Standard Exporter. Dieser führt den Export im Hintergrund durch und benachrichtigt Sie bei Abschluss per E-Mail inklusive Download-Link, sodass Sie direkt weiterarbeiten können. Sie erhalten hier lediglich etwas mehr Daten als beim Hiltes Exporter."
            },
            "selections": {
                "selections": "Mailingselektionen",
                "selection": "Mailingselektion",
                "new": "Neue Mailingselektion",
                "edit": "Mailingselektion bearbeiten",
                "save": "Mailingselektion speichern",
                "created": "Mailingselektion erstellt",
                "updated": "Mailingselektion aktualisiert",
                "deleted": "Mailingselektion gelöscht",
                "campaign_missing": "Geben Sie bitte die zu exportierende Kampagne an",
                "campaign_notification_missing": "Geben Sie bitte die zu exportierende Push-Nachricht an",
                "v3_campaign_notification_missing": "Geben Sie bitte die zu exportierende Nachricht an",
                "name": "Name",
                "type": "Typ",
                "created_at": "erstellt am",
                "types": {
                    "standard": "Selektion nach Stamm- und Bewegungsdaten",
                    "combine": "Kombination bereits gespeicherter Selektionen"
                },
                "field": "Feld",
                "parameter_fields": {
                    "customers": {
                        "salutation": "Anrede"
                    }
                },
                "operator": "Operator",
                "value": "Wert",
                "add_parameter": "Stammdatenabfrage hinzufügen",
                "add_view": "Bewegungsdatenabfrage hinzufügen",
                "add_selection": "Mailingselektion hinzufügen",
                "contains": "enthält",
                "in": "einer von",
                "not_in": "keiner von",
                "no": "Nein",
                "yes": "Ja",
                "undefined": "nicht festgelegt",
                "submit": "Selektion ausführen",
                "selection_parameters": "Selektionsparameter",
                "export_customers_excel": "Kunden als Excel exportieren (.xlsx)",
                "export_customers_csv": "Kunden als CSV exportieren (.csv)",
                "export_campaign_customers_excel": "Kunden für Kampagnen-Aussendungen exportieren (Excel)",
                "export_campaign_customers_csv": "Kunden für Kampagnen-Aussendungen exportieren (CSV)",
                "export_notification_customers_excel": "Kunden für Push-Nachrichten-Aussendungen exportieren (Excel)",
                "export_notification_customers_csv": "Kunden für Push-Nachrichten-Aussendungen exportieren (CSV)",
                "export_notification_customers_excel_v3": "Kunden für Nachrichten exportieren (Excel)",
                "export_notification_customers_csv_v3": "Kunden für Nachrichten exportieren (CSV)",
                "export_customers_for_campaign": "Export der Kundendaten für eine bestimmte Kampagne",
                "export_customers": "Kunden exportieren",
                "view_type": "Verknüpfung",
                "view": "Abfrage",
                "views": {
                    "new_customers": "Neukunden",
                    "sales_volume": "Umsatz",
                    "profit_volume": "Rohertrag",
                    "sales_frequency": "Anzahl Käufe",
                    "product_group": "Warengruppe",
                    "label": "Marke",
                    "supplier": "Lieferant",
                    "store": "Filiale"
                },
                "view_types": {
                    "and": "und",
                    "or": "oder",
                    "and_not": "und nicht"
                },
                "minimum_sales_volume": "Umsatz mindestens",
                "maximum_sales_volume": "Umsatz höchstens",
                "minimum_profit_volume": "Rohertrag mindestens",
                "maximum_profit_volume": "Rohertrag höchstens",
                "minimum_sales_frequency": "Anzahl Einkäufe mindestens",
                "maximum_sales_frequency": "Anzahl Einkäufe höchstens",
                "product_group_name": "Warengruppe",
                "label_name": "Marke",
                "supplier_name": "Lieferant",
                "store_name": "Filiale",
                "percent": "Umsatzanteil in %",
                "this_month": "Aktueller Monat",
                "fields": {
                    "birth_month": "Geburtsmonat",
                    "birth_month_and_day": "Geburtsmonat und -tag"
                },
                "operators": {
                    "is": "=",
                    "in": "einer von",
                    "notIn": "keiner von",
                    "like": "enthält",
                    "gt": "größer",
                    "lt": "kleiner",
                    "gte": "größer/gleich",
                    "lte": "kleiner/gleich",
                    "undefined": "nicht definiert",
                    "defined": "vorhanden"
                },
                "determined_result": "Die ausgewählte Selektion beinhaltet {number_of_customers} Kunden."
            },
            "v3_campaigns": {
                "auto": "Auto-",
                "id": "Kampagnen ID",
                "campaigns": "Kampagnen",
                "auto_campaigns": "Auto-Kampagnen",
                "campaign": "Kampagne",
                "creator": "Ersteller der Kampagne",
                "v3_campaign": "Kampagne 3.0",
                "v3_campaigns": "Kampagnen 3.0",
                "new": "Neue Kampagne",
                "continue": "Letzte Kampagne bearbeiten",
                "new_auto": "Neue Auto-Kampagne",
                "edit": "Kampagne bearbeiten",
                "save": "Kampagne abspeichern",
                "created": "Kampagne erstellt",
                "updated": "Kampagne gespeichert",
                "updating": "Die Texte der Kampagne werden nun im Hintergrund aktualisiert",
                "updating_failed": "Die Aktualisierung wurde bereits gestartet",
                "started": "Kampagne gestartet",
                "stopped": "Kampagne gestoppt",
                "canceled": "Kampagne abgebrochen",
                "test_customer_send": "Testaussendungen wurden verschickt",
                "test_customer_maximum_reached": "Es können nur maximal 20 Testaussendungen auf verschickt werden.",
                "test_customer_missing": "Die Aussendung wurde durchgeführt, es gab allerdings Warnungen: <br>",
                "test_customer_title": "Testkundenaussendung",
                "continued": "Kampagne wird fortgesetzt",
                "deleted": "Kamapgne gelöscht",
                "type": "Typ",
                "not_found": "Die von Ihnen angeforderte Kampagne konnten wir leider nicht finden. Sie wurde entweder nicht abgespeichert oder gelöscht.",
                "templates_not_found": "Es wurden keine Vorlagen gefunden",
                "template": "Vorlage für die Kampagne",
                "templates": "Vorlagen",
                "template_package": "Vorlagenpaket",
                "template_packages": "Verfügbare Vorlagenpakete",
                "template_id": "Vorlagen-ID",
                "template_id_provisional": "Vorläufige Vorlagen-ID",
                "template_state": "Vorlagenstatus",
                "template_name": "Vorlagenname",
                "template_load": "Vorlage laden",
                "template_submit": "Vorlage speichern",
                "template_saved": "Vorlage abgespeichert",
                "template_edit": "Vorlage bearbeiten",
                "template_choose": "Vorlage wählen",
                "name_internal": "Interner Name",
                "preset": {
                    "preset": "Vorlage",
                    "new": "Neue Vorlage erstellen",
                    "save": "Vorlage speichern",
                    "loaded": "Die Vorlage wurde angewandt!",
                    "none_loaded": "Keine Vorlage geladen",
                    "check": "Sind Sie sich sicher, dass Sie die Vorlage laden wollen? Die bestehende Kampagne wird überschrieben. Vorlage: "
                },
                "send": "Aussendungsoptionen",
                "send_info": "Legen Sie hier fest, an welche Kunden eine Aussendung erfolgen soll.",
                "send_file_missing": "Bitte laden Sie eine CSV- oder XLSX-Datei als externe Adressdatei hoch",
                "send_to_file": "An externe Adressdatei",
                "send_to_file_format": "Format",
                "send_to_file_format_types": {
                    "csv": "CSV UTF-8",
                    "excel": "Excel XLSX"
                },
                "next": "Weiter zum Abschnitt",
                "back": "Zurück zum Abschnitt",
                "back_index": "Zurück zur Kampagnenübersicht",
                "submit": "Kampagne speichern",
                "steps": [
                    " Kampagnenübersicht",
                    " Aussendungsdaten",
                    " Impuls",
                    " Filter",
                    " Listenansicht",
                    " Detailansicht",
                    " Funktionalität",
                    " Zeiträume",
                    " Nachrichten",
                    " Automonitoring",
                    " Aussendungssteuerung"
                ],
                "state_strings": [
                    "0CampaignsIndex",
                    "1SendData",
                    "2Impulse",
                    "3Selection",
                    "4List",
                    "5Detail",
                    "6Functionality",
                    "7Times",
                    "8Notifications",
                    "9Monitorings",
                    "10SendControl",
                    "11FullyConfigured",
                    "12Started",
                    "13Sent",
                    "14Stopped",
                    "15Canceled",
                    "16UpdateTexts",
                    "17SendTestCampaignCustomers"
                ],
                "step4": {
                    "invitation": "Teilnehmen-Funktion",
                    "bonus_voucher": "Einlösen-Funktion",
                    "coupon": "Einlösen-Funktion"
                },
                "variables": {
                    "customer": "Kundendaten aus dem smart.KIS",
                    "info_title": "Informationen zu Variablen",
                    "info": "Mit dem @-Zeichen können Sie in den Text Variablen einfügen. Nachfolgend finden Sie ausklappbaren Listen der verfügbaren Variablen inklusive Beschreibung. Es werden nur Bezeichnungen ersetzt, die in den Listen zu finden sind. Bitte testen Sie Aussendungen mit Variablen vor dem Starten. Bitte stellen Sie sicher, dass eine Variable keine unteschiedliche Formatierung vom selben Typ hat, wie bspw. zwei verschiedene Textfarben, da diese sonst nicht erkannt werden.",
                    "campaign": {
                        "campaign{name}": "Der Kampagnenname"
                    },
                    "file": {
                        "name": "Variablen aus Adressdatei"
                    }
                },
                "state": {
                    "state": "Status",
                    "finished": "Fertiggestellt",
                    "unfinished": "Vorläufig",
                    "started": "Gestartet",
                    "stopped": "Gestoppt",
                    "canceled": "Abgebrochen",
                    "sent": "Ausgesendet"
                },
                "expected_send_file": "Es wird eine Datei, in der in der ersten Spalte die Kundennummer gelistet ist, erwartet. Weitere Spalten werden als Variablen hinzugefügt. Bei den Spaltennamen werden Sonderzeichen durch _ ersetzt. Maximale Dateigröße: 16 MB",
                "expected_block_file": "Es wird eine Datei mit einer Spalte ohne Überschrift, in der sich Kundennummern befinden, erwartet.",
                "empty_key": "Der Name der Spalte %s ist leer.",
                "list_text": "Freitext in der Listenansicht",
                "image_info_tooltip": "Die optimalen Bildmaße liegen bei 1141x513 Pixel. Sie haben die Möglichkeit in der Breite zwischen 1200 und 1100 und in der Höhe zwischen 540 und 490 zu variieren. Die maximale Dateigröße beträgt 150KB.",
                "list_text_alignment": {
                    "alignment": "Größe der Fläche für den Text",
                    "options": {
                        "full": "Gesamtes Bild",
                        "right_side": "Rechte Hälfte"
                    }
                },
                "list_text_alignment_vertical": {
                    "alignment": "Vertikale Ausrichtung des Textes",
                    "options": {
                        "top": "Oben",
                        "middle": "Mitte",
                        "bottom": "Unten"
                    }
                },
                "subline": "Subline",
                "preview": "Vorschau",
                "update_preview": "Vorschau aktualisieren",
                "preview_not_available": "Es ist keine Vorschau verfügbar, da die Funktionalität nicht verwendet wird",
                "send_type": "Aussendungsart",
                "send_types": {
                    "file_upload": "An externe Adressdatei",
                    "app_user": "An alle App-User zum Startzeitpunkt ",
                    "app_user_time": "An alle App-User zu einem Zeitpunkt",
                    "selection": "An Kunden aus smart.KIS Selektion",
                    "registration": "Nur bei Aktivierung und Registierung"
                },
                "auto_send_types": {
                    "impulse": "Impuls-gesteuert",
                    "rhythm": "Rhythmus-gesteuert",
                    "external": "Fremdsteuerung"
                },
                "send_file_warn": "Sie haben keine Adressdatei hochgeladen. Sie können die Kampagne weiter bearbeiten und auch abspeichern. Um sie allerdings starten zu können, müssen Sie eine Datei unter \"Aussendungsdaten\" hochladen",
                "send_on_registration": "Ergänzend bei Registrierung / Aktivierung aussenden",
                "send_types_fields": {
                    "file_upload": "Adressdatei hochladen ",
                    "selection_choose": "Selektion auswählen",
                    "birthday_info": "Bitte beachten Sie, dass Geburtstagsgutscheine nur versendet werden, wenn die Person sich mindestens 24 Stunden zuvor registriert hat.",
                    "selection_time": "Selektion zu einem Zeitpunkt neu ausführen",
                    "pp_user_info": "Der Aussendungszeitpunkt ist der Startzeitpunkt der Kampagne"
                },
                "add_on_registration": "Bei Registrierung oder Aktivierung eine Aussendung erstellen",
                "choose_datetime": "Zeitpunkt auswählen",
                "choose_time": "Uhrzeit auswählen",
                "send_blocker": "Kundennummern sperren",
                "send_blocker_file": "Sperrdatei verwenden ",
                "send_blocker_file_upload": "Sperrdatei hochladen ",
                "send_to_wrong_format_excel": "Die externe Adressdatei konnte nicht als XLSX-Datei geöffnet werden. Bitte prüfen Sie das Format und versuchen Sie erneut die Datei hochzuladen.",
                "send_blocker_wrong_format_excel": "Die Sperrdatei konnte nicht als XLSX-Datei geöffnet werden. Bitte prüfen Sie das Format und versuchen Sie erneut die Datei hochzuladen.",
                "send_wrong_format_csv": "Die externe Adressdatei ist nicht als UTF-8 CSV formatiert. Bitte prüfen Sie das Format und versuchen Sie erneut die Datei hochzuladen.",
                "block_wrong_format_csv": "Die Sperrdatei ist nicht als UTF-8 CSV formatiert. Bitte prüfen Sie das Format und versuchen Sie erneut die Datei hochzuladen.",
                "block_description": "Aus der Datei <b>%s</b> vom %s um %s Uhr wurden <b>%s</b> eindeutige Kundennummern ausgewählt",
                "send_description": "Aus der Datei <b>%s</b> vom %s um %s Uhr wurden <b>%s</b> Einträge mit <b>%s</b> Variablen importiert",
                "show_in_app_module": "Anzeige im App Modul",
                "list_config": "Optionen für die Listansicht",
                "detail_config": "Optionen für die Detailansicht",
                "redeem_config": "Ansicht: Gutschein einlösen",
                "event_config": "Events",
                "sign_up_config": "Ansicht: Zu Event anmelden",
                "banner_config": "Balkenoptionen",
                "times_config": "Zeitraum-Konfiguration",
                "show": {
                    "days": "Anzeigeende nach der Erstellung in Tagen",
                    "days_tooltip": "Hier können Sie ein Anzeigeende in Tagen nach der Erstellung einer Aussendung angeben. Beim Wert 0 werden die Anzeigezeiträume genutzt.",
                    "list": "Anzeigezeitraum der Kampagne in der Listenansicht",
                    "detail": "Anzeigezeitraum der Kampagne in der Detailansicht",
                    "start": "Startzeitpunkt",
                    "end": "Endzeitpunkt",
                    "expired_banner": "Balken \"Kampagne ist abgelaufen\" nutzen (Balken wird ab dem Endzeitpunkt der Detailansicht eingeblendet)",
                    "expired_banner_text": "Text auf Balken",
                    "expired_banner_variable_button": "Variable in Text einfügen",
                    "expired_banner_tooltip": "Mit der Variable @aussendung_gueltig_bis können Sie das Ablaufdatum im Format TT.MM.JJJJ SS{mm}{ss} einfügen.",
                    "expired_banner_color": "Balkenfarbe"
                },
                "automonitoring": {
                    "start": "Auswertungszeitraum Start",
                    "end": "Auswertungszeitraum Ende",
                    "comparison": {
                        "type": "Vergleichszeitraum",
                        "types": {
                            "previous": "Mit Zeitraum aus Vorjahr vergleichen",
                            "custom": "Einen Zeitraum definieren"
                        },
                        "start": "Vergleichzeitraum Start",
                        "end": "Vergleichzeitraum Ende"
                    },
                    "name": "Name des Monitorings",
                    "add": "Monitoring hinzufügen",
                    "delete": "Monitoring löschen",
                    "none": "Keine Monitorings angelegt"
                },
                "notifications": {
                    "info": "Die hier aufgeführten Nachrichten werden zum Startzeitpunkt der Kampagne erstellt. Sie finden diese nach dem Starten der Kampagne in der normalen Übersicht.",
                    "add": "Nachricht hinzufügen",
                    "delete": "Nachricht löschen",
                    "none": "Keine Nachrichten angelegt"
                },
                "event": {
                    "campaign_no_events": "Kampagne hat keine Events",
                    "campaign_choose_info": "Bitte wählen Sie eine einzelne Kampagne aus, um hier den Buchungsstatus der dazugehörigen Events zu sehen",
                    "change": "Teilnehmerzahl ändern",
                    "ignore_maximum": "Maximale Teilnehmeranzahl ignorieren",
                    "current_new": "Neue Teilnehmerzahl",
                    "current": "Teilnehmerzahl",
                    "count_for_events": "Teilnehmerzahlen für Events",
                    "total_current": "Teilnehmerzahl insgesamt",
                    "internal_name_tooltip": "Der Name des Events in der Gästeliste",
                    "delete": "Event löschen",
                    "events": "Events verwalten",
                    "event": "Event",
                    "add": "Event hinzufügen",
                    "tooltip": "In diesem Feld sind Variablen verwendbar",
                    "text": "Text in der App",
                    "use_register": "Funktionalität \"Teilnehmeranzahl festelegen\" verwenden",
                    "text_register": "Terminbeschreibung in der App",
                    "maximum_participants": "Maximale Gesamtteilnehmeranzahl für dieses Event",
                    "registration_minimum": "Minimale Teilnehmeranzahl je App-Kunde",
                    "registration_maximum": "Maximale Teilnehmeranzahl je App-Kunde",
                    "registration_ends_at": "Anmeldeschluss (Gilt auch für Änderungen und Abmeldungen):",
                    "send_sign_up_mail": "Auto-Anmeldebestätigung per E-Mail verschicken",
                    "send_sign_up_chat_message": "Auto-Anmeldebestätigung per Chat-Nachricht verschicken",
                    "send_sign_off_mail": "Auto-Abmeldebestätigung per E-Mail verschicken",
                    "send_sign_off_chat_message": "Auto-Abmeldebestätigung per Chat-Nachricht verschicken",
                    "insert_link": "Variable für den Link zum Termin einfügen",
                    "sign_up_message": "Text für automatische Anmeldebestätigung",
                    "sign_off_message": "Text für automatische Abmeldebestätigung",
                    "send_info": "Benachrichtigung je Anmeldung/Abmeldung per E-Mail an",
                    "send_info_addresses": "E-Mailadressen (durch Strichpunkt ; getrennt)",
                    "insert_variable": "Variable für die Teilnehmerzahl einfügen",
                    "link_tooltip": "Es wird ein Termin für den Kalender ihrer Kunden erstellt, der von den Standard-Kalendern von Android und iOS, sowie den gängigen E-Mailprogrammen unterstützt wird.",
                    "count": "Personenzahl",
                    "count_error": "Änderung nicht möglich. Die maximale Teilnehmerzahl (%s) für dieses Event wird überschritten.",
                    "event_customer": {
                        "event_customers": "Gästelisten",
                        "event_customer": "Event-Anmeldung",
                        "edit": "Anmeldung bearbeiten",
                        "saved": "Die Teilnehmerzahl wurde geändert!",
                        "deleted": "Die Anmeldung wurde gelöscht!"
                    },
                    "appointment_use": "Link zum Termin (ICS-Datei) für Kalender verwenden",
                    "appointment_title": "Termintitel im Kalender",
                    "appointment_description": "Terminbeschreibung im Kalender",
                    "appointment_start": "Startzeitpunkt",
                    "appointment_end": "Endzeitpunkt"
                },
                "sign_up": {
                    "sign_up": "Teilnehmen Funktion anzeigen / nutzen",
                    "text": "Text für Button in Detailansicht",
                    "limit": "Anzahl der buchbaren Events / Termine pro Nutzer",
                    "info_booked": "Infotext für Stati \"Ausgebucht\" und \"Anmeldeschluss vorbei\"",
                    "into_tooltip": "Es öffnet sich beim Klicken auf \"Teilnehmen\" oder \"Ändern\" ein Popup-Fenster mit diesem Text",
                    "banner": "Text in Balken „Angemeldet“ in Listen und Detailansicht",
                    "banner_color": "Farbe des Balkens",
                    "buttons": {
                        "in": "Text auf Anmelden-Button",
                        "change": "Text auf Ändern-Button",
                        "out": "Text auf Abmelden-Button"
                    }
                },
                "start": {
                    "state": {
                        "provisional": "Die Kampagne wurde von %s erstellt",
                        "saved": "Die Kampagne wurde von %s vervollständigt",
                        "test": "Die Kampagne wurde von %s an Testkundennumern ausgesendet",
                        "started": "Die Kampagne wurde von %s gestartet",
                        "stopped": "Die Kampagne wurde von %s gestoppt",
                        "canceled": "Die Kampagne wurde von %s abgebrochen",
                        "texts_updated": "Die Freitexte der Kampagne wurden von %s aktualisiert",
                        "send": "Kampagne wurde von %s an die Kundennummern %s ausgesendet. ",
                        "send_missing": "Die Kundennummern %s wurden nicht im Kundenstamm gefunden. ",
                        "send_not_found": "Die Kundennummern %s wurden nicht in der Adressdatei gefunden, aber ausgesendet. Variablen aus der Datei wurden nicht ersetzt. ",
                        "title": "Bearbeitungsverlauf",
                        "current": {
                            "current": "Kampagnenstatus",
                            "started": "Gestartet",
                            "stopped": "Gestoppt",
                            "provisional": "Noch nicht abgespeichert",
                            "saved": "Noch nicht gestartet",
                            "sending": "Wird gerade ausgesendet"
                        }
                    },
                    "test_customer_identifiers_tooltip": "Die Kundennummern sind durch Kommata getrennt.",
                    "test_customer_identifiers": "Testkundennummern (Maximal 20)",
                    "send_to_test_customers": "An Testkundennummern aussenden",
                    "save_and_start_campaign": "Kampagne abspeichern und starten",
                    "cancel_campaign": "Kampagne sofort abbrechen",
                    "stop_campaign": "Kampagne stoppen",
                    "update_text": "Texte auf Aussendungen aktualisieren",
                    "update_text_impossible": "Die Aktualisierung der Texte läuft gerade im Hintergrund",
                    "campaign_finished": "Die Kampagne ist bereits vollständig ausgesendet worden",
                    "campaign_canceled": "Die Kampagne wurde abgebrochen. Ihre Aussendungen werden nicht in der App angezeigt.",
                    "campaign_stopped": "Die Aussendung der Kampagne ist gestoppt. Ihre Aussendungen sind ggf. noch in der App sichtbar."
                },
                "redeem": {
                    "redeemable": "Einlösen-Funktion anzeigen / nutzen",
                    "multiple": "Gutschein soll mehrfach eingelöst werden können",
                    "text": "Text für Button in der Detailansicht",
                    "start": "Startzeitpunkt des Anzeigezeitraums",
                    "end": "Endzeitpunkt des Anzeigezeitraums",
                    "days": "Gütigkeit nach Erstellung in Tagen",
                    "days_tooltip": "Hier können Sie die Gültigkeit des Gutscheins in Tagen nach der Aussendung angeben. Dies ist vor allem sinnvoll für Auto-Gutscheine. Beim Wert 0 ist der Gutschein im gesamten Einlöse-Zeitraum gültig.",
                    "text_1": "Text oberhalb des Codes",
                    "code": "Code",
                    "code_toolip": "In diesem Feld sind ggf. Variablen aus einer externen Adressdatei mit @ verwendbar. Anonsten ist lediglich ein statischer Code möglich.",
                    "code_text": "Code ergänzend als Text darunter anzeigen",
                    "text_2": "Text unterhalb des Codes",
                    "left_button": "Text auf Bestätigen-Button (Links)",
                    "right_button": "Text auf Abbrechen-Button (Rechts)",
                    "redeemed": "Einblendung des „Eingelöst“-Balkens in Listenansicht / Detailansicht“",
                    "redeemed_choices": {
                        "list_only": "Anzeige des „Eingelöst“-Balkens auf dem Kampagnenbild in der Listenansicht - die\nDetailansicht der Kampagne soll nicht mehr geöffnet werden können",
                        "list_and_detail": "Anzeige des „Eingelöst“-Balkens auf dem Kampagnenbild in der Listenansicht - die\nDetailansicht der Kampagne soll bis zum eingestellten Endzeitpunkt der Detailansicht\ngeöffnet werden können - der Einlösebutton wird ausgeblendet"
                    },
                    "banner_text": "Text auf Eingelöst-Balken",
                    "banner_tooltip": "Mit der Variable @aussendung_eingeloest_am können sie das Einlöse-Datum im Format TT.MM.JJJJ einfügen",
                    "banner_color": "Farbe des Eingelöst-Balkens",
                    "backwards": {
                        "title": "Rückwärtsgutschein-spezifische Optionen",
                        "value": "Gutscheinwert bzw. Anfangswert",
                        "value_tooltip": "Hier können Sie den Gutscheinwert festlegen, welcher mit @coupon_value eingefügt werden kann. Bei einem Rückwärtsgutschein dürfen nur ein Komma, keine Punkte oder Sonderzeichen verwendet werden.",
                        "discount": "Rabatt pro Einkauf in Prozentpunkten",
                        "exclude_product_group_1": "Hauptwarengruppen ausschließen - Durch Strichpunkt getrennt",
                        "exclude_product_group_2": "Unterwarengruppen ausschließen - Durch Strichpunkt getrennt"
                    }
                },
                "provisional_campaign_id": "Vorläufige Kampagnen-ID",
                "provisional_campaign_id_info": "Die ID der Kampagne ist vorläufig, da sie noch nicht vollständig bearbeitet wurde. Sind Kampagnen 48 Stunden nach ihrer letzten Bearbeitung unvollständig, werden sie gelöscht.",
                "module": {
                    "module": "Modul",
                    "modules": {
                        "coupons": "Gutscheine",
                        "bonus_vouchers": "Bonusschecks",
                        "invitations": "Einladungen"
                    }
                },
                "headline": "Headline",
                "friends": {
                    "minimum_order_value": "Formel für den Mindesteinkaufswert",
                    "minimum_order_value_info": "In diesem Feld können Sie eine Formel die Berechnung des Wertes vergeben und anschließend testen.<br> Die Variable x steht für den aktuellen Gutscheinwert.<br>Die Variable x muss nicht enthalten sein; eine einzelne Zahl ist also auch in Ordnung.<br>Sie können folgende Operatoren verwenden: <br> - Minus <br> + Plus <br> * Mal <br> / Geteilt <br> () Klammern.",
                    "minimum_order_value_example": "Wert für Bespielrechnung",
                    "minimum_order_value_example_execute": "Beispielrechnung durchführen",
                    "use_share_button": "Teilen-Button verwenden",
                    "share_button": "Text für den Teilen-Button",
                    "share_text": "Text für die Teilen-Funktion",
                    "calculation_type": "Art der Steigerung pro geworbener Person",
                    "calculation_types": {
                        "linear": "Gleichbleibender Betrag",
                        "formula_value": "Formel abhängig vom aktuellen Gutscheinwert",
                        "formula_friends": "Formal abhängig von der Zahl der geworbenen Personen"
                    }
                },
                "store": "Ort",
                "description": "Textfeld",
                "teaser_image": "Bild für Listenansicht",
                "body_image": "Bild für Detailansicht",
                "types": {
                    "bonus_voucher": "Bonusscheck",
                    "coupon": "Gutschein",
                    "invitation": "Einladung"
                },
                "special_types": [
                    "backwards_coupon",
                    "qr_campaign"
                ],
                "code_types": {
                    "qr": "QR Code",
                    "interleave25": "Interleave 2/5",
                    "ean13": "EAN 13",
                    "code128": "Code 128"
                },
                "code_type": "Code-Typ",
                "code": "Statischer Code",
                "link": "Verlinkung",
                "google_analytics_campaign_code": "Google Analytics Kampagnen-Code",
                "campaign_info": "Kampagneninformationen (Anzeige in der App)",
                "code_info": "Angaben zum Barcode/QR Code",
                "image_info": "Bilder",
                "additional_info": "Weitere Informationen",
                "all_languages": "Für alle Sprachen",
                "upload_file": "Datei hochladen (CSV UTF-8 oder XLSX)",
                "auto_upload_file": "Beispieldatei hochladen (CSV UTF-8 oder XLSX)",
                "backwards_coupon_info": "Bei einem Rückwärtsgutschein wird als Wert eine Ganz- oder Kommazahl erwartet. Weitere Zeichen sind ungültig. In der App wird der Wert in € dargestellt.",
                "backwards_coupon_warning": "Bei Rückwärtsgutscheinen darf als Wert nur eine Zahl mit einem Punkt oder Komma als Dezimaltrenner angegeben werden!",
                "with_start_and_end_date": "Kampagne mit Start - und Enddatum(nicht kombinierbar)",
                "with_fixed_date": "Kampagne mit fixem Datum(nicht kombinierbar)",
                "campaign_validity_info": "Laufzeit der Kampagne",
                "expiration_info": "Anzeige und Verfallsdatum",
                "registration_offer": "Aussendung bei Registrierung über die App",
                "active": "Für Kunden sichtbar",
                "inactive": "Nicht für Kunden sichtbar",
                "has_campaign_customers": "Hat Aussendungen",
                "does_not_have_campaign_customers": "Hat keine Aussendungen",
                "impulse": {
                    "impulse": "Impulse",
                    "use_timeframe": "Uhrzeit für die Aussendung begrenzen",
                    "earliest": "Früheste Uhrzeit für die Aussendung",
                    "latest": "Späteste Uhrzeit für die Aussendung",
                    "behaviour": "Verhalten bei Impulsen außerhalb des Aussendungszeitraums",
                    "behaviour_choices": {
                        "delay": "Bis zum nächsten Aussendungszeitraum verzögern",
                        "ignore": "Nicht aussenden"
                    }
                },
                "impulses": {
                    "beacon": "Beacon",
                    "geo-fence": "Geo-Fence",
                    "sale": "Nur Einkauf",
                    "refund": "Nur Retoure",
                    "sale-refund-mixed": "Einkauf und Retoure gemischt",
                    "registration": "Bei Aktivierung"
                },
                "filter": {
                    "filter": "Filter",
                    "filter_use": "Filter verwenden",
                    "parameters": "Filterparameter"
                },
                "timespan": {
                    "unit": "Einheit",
                    "from": "Zeitspanne rückwirkend ab",
                    "until": "Zeitspanne rückwirkend bis",
                    "types": {
                        "hours": "Stunden",
                        "days": "Tage",
                        "weeks": "Wochen",
                        "months": "Monate"
                    },
                    "conversions": {
                        "hours": "1",
                        "days": "24",
                        "weeks": "168",
                        "months": "720"
                    }
                },
                "rhythm": {
                    "rhythm": "Rhythmus",
                    "interval": "Interval für den Rhythmus",
                    "interval_unit": "Zeiteinheit des Intervals",
                    "start": "Ersten Rhythmus ausführen",
                    "start_types": {
                        "instantly": "Sofort nach dem Starten der Kampagne",
                        "on_second_rhythm": "Beim zweiten Rhythmus nach dem Starten",
                        "time": "Zu einem Zeitpunkt"
                    },
                    "time": "Startzeitpunkt",
                    "info": "Der Rhythmus gibt an, wie oft die Selektion automatisch ausgeführt wird. Bspw. mit dem Zeitpunkt der ersten Ausführung am 02.01.2021 um 12{00}{00} Uhr und dem Rythmus 2 Tage, wird die Selektion am 02.01.2021, 04.01.2021, 06.01.2021 und so weiter jeweils um 12{00}{00} Uhr ausgeführt und ausgesendet.",
                    "begin": {
                        "rhythm_begin": "Erste Ausführung",
                        "options": {
                            "instant": "Beim Starten",
                            "one_rhythm": "Einen Rhythmus nach dem Start",
                            "datetime": "Zu einem Zeitpunkt"
                        }
                    }
                },
                "campaign_customers": {
                    "campaign_controlled": "Zeiträume, durch die Kampagne gesteuert",
                    "campaign_customer_controlled": "Zeiträume, pro Aussendung individuell (überschreibt Kampagne)",
                    "list_start": "Beginn der Anzeige in der Listenansicht",
                    "list_end": "Ende der Anzeige in der Listenansicht",
                    "detail_start": "Beginn der Anzeige in der Detailansicht",
                    "detail_end": "Ende der Anzeige in der Detailansicht"
                },
                "tags": {
                    "tags": "Tags",
                    "list": {
                        "christmas": "Weihnachten",
                        "spring": "Frühling",
                        "summer": "Sommer",
                        "fall": "Herbst",
                        "winter": "Winter",
                        "sale": "Schlussverkauf"
                    }
                },
                "variable_explanations": {
                    "customer": {
                        "customer_identifier": "Die Kundennummer",
                        "internal_customer_identifier": "Die interne Kundennummer, falls genutzt",
                        "card_number": "Die Kartennummer, falls genutzt",
                        "family_number": "Die Familiennummer, fall genutzt",
                        "translatedSalutation": "Die Anrede",
                        "fullSalutation": "Die förmliche, geschlechter-abhängige Anrede inkl. Titel, z.B. \"Sehr geehrte Frau Dr.\" ",
                        "dearFullSalutation": "Die alternative, geschlechter-abhängige Anrede inkl. Titel, z.B. \"Liebe Frau Dr.\" ",
                        "title": "Der Titel",
                        "first_name": "Der Vorname",
                        "last_name": "Der Nachname",
                        "address_1": "Die Strasse, ggf. inklusive der Hausnummer",
                        "address_2": "Ein Adresszusatz",
                        "street_number": "Die Hausnummer, falls sie in einem separaten Feld geführt wird",
                        "zip": "Die Postleitzahl",
                        "city": "Der Wohnort",
                        "country_iso_3166_1": "Der Ländercode, bspw. DE für Deutschland",
                        "date_of_birth": "Das Geburtsdatum",
                        "email": "Die Email",
                        "app_email": "Die Email, die zur Aktivierung der App verwendet wurde",
                        "phone_work": "Die Telefonnummer in der Arbeit",
                        "phone_mobile": "Die Mobiltelefonnummer",
                        "phone_home": "Die Telefonnummer daheim",
                        "logins": "Die Anzahl der Logins"
                    },
                    "campaign_customer": {
                        "code": "Der Code der Aussendung",
                        "value": "Der aktuelle Wert der Aussendung",
                        "expires_at": "Das Datum, bis zu dem die Aussendung gültig ist (Detailansicht)",
                        "show_until": "Das Datum, bis zu dem die Aussendung angezeigt wird (Listenansicht)",
                        "created_at": "Das Erstellungsdatum der Aussendung",
                        "redeemed_at": "Das Einlösedatum bei Gutscheinen und Bonusschecks",
                        "detailStartSend": "Der Beginn der Anzeige in der Detailansicht",
                        "detailEndSend": "Das Ende der Anzeige in der Detailansicht",
                        "listEndSend": "Das Ende der Anzeige in der Listenansicht"
                    }
                },
                "external": {
                    "external": "Fremdsteuerung",
                    "not_setup": "Die Fremdsteuerung (bspw. durch Value IQ) arbeitet momentan nur dateibasiert. Hierfür benötigen Sie einen Zugang zu unserem FTP-Server. Bitte kontaktieren Sie Ihre Ansprechpartnerin / Ihren Ansprechpartner im Projektmanagement, falls Sie eine Fremdsteuerung wünschen.",
                    "sample_file": "Beispieldatei",
                    "sample_file_info": "Die Beispieldatei muss die Spaltenbezeichnungen beinhalten, die vom steuernden System ausgesendet werden. Die erste Spalte steht nicht als Variable im Gutschein zu Verfügung; Es wird davon ausgegangen, dass es sich bei ihr um die Kundennummer handelt."
                }
            },
            "selection_data_import": {
                "form": {
                    "export_as": "erstellte Datei exportieren als:",
                    "same_as_import": "gleich dem Importformat",
                    "excel": "Excel (xlsx)",
                    "csv": "Comma-separated values (csv)",
                    "button_data_selection": "Stammdatenselektion hinzufügen",
                    "includeSmartkisData": "Alle Stammdaten aus smart.KIS hinzufügen",
                    "includeAppData": "Appdaten aus smart.KIS hinzufügen",
                    "info_text_file_type": "Hier können Sie eine .xlsx, .xls oder .csv Kundendatei hochladen. Bitte beachten Sie:<br/>\n                                <ul>\n                                    <li>Datumsfelder bitte immer mit Format \"YYYY-mm-dd\" angeben</li>\n                                    <li>als Codierungsformat bei csv-Dateien bitte \"UTF-8\" bzw. \"UTF-8 mit BOM\" wählen</li>\n                                    <li>Zahlen: Dezimalstellen mit Komma getrennt; keine Tausendertrennzeichen</li>\n                                </ul>\n                                Die importierten Daten können mit den im smartKIS vorhandenen Datenfelder „Benutzt APP“ und „Aktivierungscode“ oder mit allen Stammdaten aus dem smartKIS angereichert werden. Das Matching erfolgt über die Kundennummer.<br/><br/>\n                                Ergänzend kann die hochgeladene Datei nach Kanälen gesplittet ausgegeben werden in dem eine Selektion (eine oder mehrere Stammdatenselektion(n) hinzufügen) durchgeführt wird, z.B.:\n                                <ul>\n                                    <li>Selektion aller APP User: Benutzt APP = ja (zur Bewerbung per APP)</li>\n                                    <li>Selektion aller die die APP nicht nutzen: Benutzt APP = nein (zur Bewerbung aller nicht APP User per Post)</li>\n                                </ul>\n                                Wichtig:<br/>\n                                Bitte stellen Sie bei den hochzuladenden Daten sicher, dass die erste Spalte in Ihrer Importdatei immer die Kundennummern beinhalten und die Spaltenüberschrift „Kundennummer“ heißt. Bei nicht Beachtung kann kein korrektes Ergebnis ausgegeben werden!<br/><br/>\n                                Die Selektion erfolgt ausschließlich über die im smartKIS verfügbaren Felder nicht über die von Ihnen importierten Felder.\n        ",
                    "info_text_data_selection": "Mit dem hinzufügen einer Stammdatenselektion können Sie in Ihrer Importierten Datei gezielte Selektionen vornehmen. Dadurch definieren und wählen Sie aus, welche genaue Gruppe Sie aus Ihrer Datei mit Daten anreichern wollen.",
                    "info_text_smart_kis_data": "(Diese Option fügt folgende Spalten aus Ihren smart.KIS-Stammdaten an Ihre importierte Datei: Titel, Anrede, Vorname, Nachname, Straße, Hausnummer, PLZ, Ort, Telefon, Mobil, Geburtsdatum, Land, Sprache, Email 1, Email Einwilligung 1, Kommentar)",
                    "info_text_app_data": "(Diese Option fügt folgende Spalten aus Ihren smart.KIS-Stammdaten an Ihre importierte Datei: Benutzt App, Aktivierungscode)",
                    "info_text_submit": "Sie erhalten nach starten der Datenanreicherung eine E-Mail mit den gewünschten Daten zum Download!",
                    "button_submit": "Datenanreicherung starten"
                },
                "data_import": "Datenimport",
                "selection_data_import": "Datenanreicherung",
                "new": "Datenanreicherung",
                "define_params": "Parameter auswählen",
                "errors": {
                    "faulty_form_sending": "<h3>Achtung: Beim Import sind Fehler aufgetreten.</h3>\n                                <strong>\n                                    Der Import wurde <strong>nicht</strong> durchgeführt! Überprüfen Sie den Inhalt ihrer Datei entsprechend\n                                    der folgenden Hinweise:\n                                </strong><br>"
                },
                "export_successful": "Datenanreicherung erfolgreich durchgeführt.",
                "logging": []
            },
            "importer_mapping": {
                "mapping_title_customers": "Import-Mapping - Stammdatenimport",
                "mapping_title_transactions": "Import-Mapping - Bewegungsdatenimport",
                "mapping_title_customers_preview": "Vorschau des Stammdatenimports",
                "mapping_title_transactions_preview": "Vorschau des Bewegungsdatenimports",
                "new_mapping_fields": "Seit dieses Mapping das letzte Mal verwendet wurde, sind in der Datenbank neue Felder hinzugefügt worden:",
                "deleted_mapping_fields": "Seit dieses Mapping das letzte Mal verwendet wurde, sind in der Datenbank Felder gelöscht oder deaktiviert worden:",
                "missing_mapping_fields": "In der von Ihnen ausgewählten Datei sind Felder enthalten, die im Mapping nicht zugeordnet werden konnten:",
                "missing_customer_identifier": "Das Smart.KIS Feld Kundennummer muss mit einem belegt sein!",
                "mapping_incorrect": "Bitte füllen Sie alle Formularfelder aus!",
                "mapping_not_in_db": "Das von Ihnen ausgewählte Mapping konnte nicht in der Datenbank gefunden werden!",
                "customer_locked": "~!~Die Kundennummer ist für einen Import gesperrt: ",
                "store_invalid": "~!~Filiale nicht gefunden: ",
                "language_invalid": "~!~Spache nicht gefunden: ",
                "date_invalid": "~!~Falsches Datumsformat: ",
                "float_invalid": "~!~Keine Gleitkommazahl: ",
                "country_invalid": "~!~Ländercode ungültig: ",
                "integer_invalid": "~!~Keine Ganzzahl: ",
                "format_invalid": "~!~Falsches Format: ",
                "sale_invalid": "~!~Unbekannte Bewegungsart: ",
                "unknown_invalid": "~!~Unbekannter Fehler: ",
                "salutation_invalid": "~!~Falsches Format für Anrede: ",
                "customer_invalid": "~!~Kundennummer nicht gefunden: ",
                "employee_invalid": "~!~Verkaufspersonal nicht gefunden: ",
                "mail_error": {
                    "store_invalid": "Filiale nicht gefunden",
                    "language_invalid": "Spache nicht gefunden",
                    "date_invalid": "Falsches Datumsformat",
                    "float_invalid": "Keine Gleitkommazahl",
                    "county_invalid": "Ländercode ungültig",
                    "integer_invalid": "Keine Ganzzahl",
                    "format_invalid": "Falsches Format",
                    "sale_invalid": "Unbekannte Bewegungsart",
                    "unknown_invalid": "Unbekannter Fehler",
                    "salutation_invalid": "Falsches Format für Anrede",
                    "customer_invalid": "Kundennummer nicht gefunden",
                    "employee_invalid": "Verkaufspersonal nicht gefunden"
                },
                "mappings_loading": "Mappings für den Mandanten werden geladen, bitte warten...",
                "new_data": "Neuer Datensatz",
                "edit_mapping": "Weiter zum Mapping",
                "view_mapping": "Anzeigen",
                "back": "Zurück zur Übersicht",
                "name": "Name des Mappings: ",
                "format_option": "Formatoptionen",
                "mapping_deleted": "Das Mapping wurde gelöscht!",
                "sample_size": "Beispieldatensätze",
                "current_samples": "Aktuelle Datensätze: ",
                "show_import_only": "Nur importierte Spalten anzeigen",
                "show_all": "Alle Spalten anzeigen",
                "okay": "Das Mapping ist in Ordnung",
                "okay_explanation": "Es konnten alle Felder der Importdatei zugeordnet werden",
                "iso_infos": "Informationen zu den ISO-Normen",
                "auto_mapping": "Automatisches Mapping",
                "auto_mapping_fields": "Es wurden %s Felder automatisch zugewiesen!",
                "auto_mapping_expand": "Felder anzeigen",
                "transaction_info_title": "Bitte beachten",
                "transaction_info": "Stellen Sie sicher, dass in sämtlichen Bewegungsdaten die Preisfelder befüllt sind und Retouren negative Werte verwenden, um eine ordnungsgemäße Funktion der APP und des Smart.KIS zu gewährleisten.",
                "load_data": "100 Datensätze laden",
                "load_data_from": "Ab Datensatz: ",
                "fault_date": "~!~Kein Wert (NULL)",
                "fault_sale": "~!~Verkauf (sale)",
                "fault_salutation": "~!~Keine Angabe (n)",
                "fault_yesno": "~!~Nein (0)",
                "fault_invalid": "~!~Kein Wert (NULL)",
                "format_options": {
                    "salutations": {
                        "salutations_none": "Keine",
                        "german_salutations": "Deutsche Anreden"
                    },
                    "yes_no": {
                        "zero_one": "Keine",
                        "yes_no": "Ja / Nein"
                    },
                    "date": {
                        "unix": "JJJJ-MM-TT SS{mm}{ss}",
                        "german_date": "TT.MM.JJJJ SS{mm}{ss}",
                        "german_date_short": "TT.MM.JJJJ SS{mm}",
                        "reversed_german_date": "SS{mm}{ss} TT.MM.JJJJ",
                        "reversed_german_date_short": "SS{mm} TT.MM.JJJJ",
                        "german_base": "TT.MM.JJJJ",
                        "german_base_reversed": "JJJJ.MM.TT",
                        "german_base_dash": "JJJJ-MM-TT",
                        "german_base_dash_reversed": "TT-MM-JJJJ",
                        "german_date_dash": "TT-MM-JJJJ SS{mm}{ss}",
                        "german_date_short_dash": "TT-MM-JJJJ SS{mm}",
                        "unix_reversed": "SS{mm}{ss} JJJJ-MM-TT"
                    },
                    "language": {
                        "iso": "ISO 639-1",
                        "english": "Englisch",
                        "native": "Endonym"
                    },
                    "none": {
                        "none": "Keine"
                    },
                    "sale": {
                        "sale_none": "Keine"
                    },
                    "integer": {
                        "integer_none": "Keine"
                    },
                    "float": {
                        "float_none": "Keine"
                    },
                    "store_id": {
                        "store_none": "Keine"
                    },
                    "employee_id": {
                        "employee_none": "Keine"
                    },
                    "country": {
                        "country_none": "Keine"
                    }
                },
                "please_choose": "Bitte wählen",
                "dont_import": "Nicht importieren",
                "default_value": "Standardwert",
                "default_values": {
                    "yes_no": [
                        "(0) Nein",
                        "(1) Ja"
                    ],
                    "date": {
                        "NULL": "Keiner / Leer",
                        "2020-10-26 09{46}{20}": "Heute"
                    },
                    "salutations": {
                        "n": "Keine Angabe",
                        "c": "Firma",
                        "f": "Frau",
                        "h": "Familie",
                        "m": "Mann"
                    },
                    "language": {
                        "de": "(de) Deutsch",
                        "fr": "(fr) Französisch"
                    },
                    "none": {
                        "none": "Keiner",
                        "obligatory": "Keiner - Pflichtfeld"
                    },
                    "country": {
                        "DE": "Deutschland (DE)",
                        "AT": "Österreich (AT)",
                        "CH": "Schweiz (CH)"
                    }
                },
                "empty_override": {
                    "yes": "Ja",
                    "no": "Nein"
                },
                "continue": "Speichern und Vorschau",
                "back_to_mapping": "Mapping bearbeiten",
                "table_headers": {
                    "smartkis_field": "Smart.KIS Feld",
                    "user_field": "Eigenes Feld",
                    "formatting_options": "Formatoptionen",
                    "default_value": "Standardwert",
                    "import_empty": "Leere Werte importieren"
                },
                "tooltips": {
                    "customers": {
                        "customer_identifier": "Die eindeutige Kundennummer in Ihrer Warenwirtschaft. Die Zuordnung zu bestehenden Kundendaten basiert auf ihr.<br>\n            <i>Pflichtfeld - Werte:<br>\n            Beliebige Zeichen</i>",
                        "card_number": "Eine Kartennummer für Kundenkarten.<br>\n            <i>Werte:<br>\n            Beliebige Zeichen</i>",
                        "foreign_guid": "Ein weiteres eindeutiges Kundenmerkmal. Es wird von einigen Warenwirtschaften mandantenübergreifend vergeben.<br>\n            <i>Werte:<br>\n            Beliebige Zeichen</i>",
                        "internal_customer_identifier": "Ein weiteres eindeutiges Kundenmerkmal.<br>\n            <i>Werte:<br>\n            Beliebige Zeichen</i>",
                        "family_number": "Über dieses Merkmal können Kunden einer Familie zugeordnet werden.<br>\n            <i>Werte:<br>\n            Beliebige Zeichen</i>",
                        "store_id": "Die eindeutige ID einer Filiale. Sie können die Filialen Ihrer Warenwirtschaft mit derselben ID im Smart.KIS hinterlegen.<br>\n            <i>Werte:<br>\n            Zahl</i>",
                        "casual_customer": "Dieses Merkmal gibt an, ob es sich um Laufkunden handelt.<br>\n            <i>Werte:<br>\n            0 = Nein<br>\n            1 = Ja</i>",
                        "is_employee": "Dieses Merkmal gibt an, ob es sich um Mitarbeitende handelt.<br>\n           <i>Werte:<br>\n            0 = Nein<br>\n            1 = Ja</i>",
                        "salutation": "Die Anrede.<br>\n            <i>Werte:<br>\n            Eine der Formatoptionen. Standardwerte:<br>\n            c = Firma<br>\n            f = Frau<br>\n            h = Familie<br>\n            m = Herr<br>\n            n = Keine Angabe</i>",
                        "title": "Der Titel.<br>i\n            <i>Werte:<br>\n            Beliebige Zeichen</i>",
                        "first_name": "Der Vorname.<br>\n            <i>Werte:<br>\n            Beliebige Zeichen</i>",
                        "last_name": "Der Nachname.<br>\n            <i>Werte:<br>\n            Beliebige Zeichen</i>",
                        "address_1": "Die Adresse, eventuell inklusive Hausnummer.<br>\n            <i>Werte:<br>\n            Beliebige Zeichen</i>",
                        "street_number": "Die Hausnummer, falls separat angegeben.<br>\n            <i>Werte:<br>\n            Beliebige Zeichen</i>",
                        "address_2": "Zusätzliche Adressdaten.<br>\n            <i>Werte:<br>\n            Beliebige Zeichen</i>",
                        "zip": "Die Postleitzahl<br>\n            <i>Werte:<br>\n            Beliebige Zeichen</i>",
                        "city": "Der Wohnort<br>\n            <i>Werte:<br>\n            Beliebige Zeichen</i>",
                        "country_iso_3166_1": "Das Land<br>\n            <i>Werte:<br>\n            Länderkennung nach der Norm ISO 3166-1 Alpha 2<br>\n            Informationslinks zu den ISO-Normen finden sie unterhalb der Tabelle.</i>",
                        "language_id": "Die Sprache, in der die App angezeigt werden soll. Insofern diese verfügbar ist.<br>\n            <i>Werte:<br>\n            Eine der Formatoptionen.<br>\n            Links zu den ISO-Normen finden sie unterhalb der Tabelle.\n            Endonym = Name der Sprache für sich selbst, bspw. Französisch → Français\n            </i>",
                        "date_of_birth": "Das Geburtsdatum.<br>\n            <i>Werte:<br>\n            Eines der Formate in den Formatoptionen. Jeweils ggf. mit führender Null.<br>\n            TT = Tag<br>\n            MM = Monat<br>\n            JJJJ = Jahr<br>\n            SS = Stunde<br>\n            mm = Minute<br>\n            ss = Sekunde</i>",
                        "email": "Die E-Mailadresse<br>\n            <i>Werte:<br>\n            Beliebige Zeichen</i>",
                        "phone_home": "Private Telefonnummer<br>\n            <i>Werte:<br>\n            Beliebige Zeichen</i>",
                        "phone_work": "Arbeitstelefonnummer<br>\n            <i>Werte:<br>\n            Beliebige Zeichen</i>",
                        "phone_mobile": "Mobiltelefonnummer<br>\n            <i>Werte:<br>\n            Beliebige Zeichen</i>",
                        "last_updated_at": "Das Datum, an dem der Datensatz zuletzt in der Warenwirtschaft aktualisiert wurde.<br>\n            <i>Werte:<br>\n            Eines der Formate in den Formatoptionen. Jeweils ggf. mit führender Null.<br>\n            TT = Tag<br>\n            MM = Monat<br>\n            JJJJ = Jahr<br>\n            SS = Stunde<br>\n            mm = Minute<br>\n            ss = Sekunde</i>",
                        "comment": "Ein individueller Kommentar<br>\n            <i>Werte:<br>\n            Beliebige Zeichen</i>",
                        "email_marketing_confirmed": "Dieses Merkmal gibt an, ob die Zustimmung zum Marketing via E-Mail gegeben wurde.<br>\n           <i>Werte:<br>\n            0 = Nein<br>\n            1 = Ja</i>",
                        "email_marketing_confirmed_at": "Dieses Merkmal gibt ggf. an, wann die Zustimmung zum E-Mail-Marketing gegeben wurde.<br>\n           <i>Werte:<br>\n            Eines der Formate in den Formatoptionen. Jeweils ggf. mit führender Null.<br>\n            TT = Tag<br>\n            MM = Monat<br>\n            JJJJ = Jahr<br>\n            SS = Stunde<br>\n            mm = Minute<br>\n            ss = Sekunde</i>",
                        "classic_marketing_confirmed": "Dieses Merkmal gibt an, ob die Zustimmung zum postalischen Marketing gegeben wurde.<br>\n           <i>Werte:<br>\n            0 = Nein<br>\n            1 = Ja</i>",
                        "classic_marketing_confirmed_at": "Dieses Merkmal gibt ggf. an, wann die Zustimmung zum E-Mail-Marketing gegeben wurde.<br>\n           <i>Werte:<br>\n            Eines der Formate in den Formatoptionen. Jeweils ggf. mit führender Null.<br>\n            TT = Tag<br>\n            MM = Monat<br>\n            JJJJ = Jahr<br>\n            SS = Stunde<br>\n            mm = Minute<br>\n            ss = Sekunde</i>",
                        "app_marketing_confirmed": "Dieses Merkmal gibt an, ob die Zustimmung zum App-Marketing gegeben wurde.<br>\n           <i>Werte:<br>\n            0 = Nein<br>\n            1 = Ja</i>",
                        "app_marketing_confirmed_at": "Dieses Merkmal gibt ggf. an, wann die Zustimmung zum App-Marketing gegeben wurde.<br>\n           <i>Werte:<br>\n            Eines der Formate in den Formatoptionen. Jeweils ggf. mit führender Null.<br>\n            TT = Tag<br>\n            MM = Monat<br>\n            JJJJ = Jahr<br>\n            SS = Stunde<br>\n            mm = Minute<br>\n            ss = Sekunde</i>",
                        "phone_marketing_confirmed": "Dieses Merkmal gibt an, ob die Zustimmung zum telefonischen Marketing gegeben wurde.<br>\n           <i>Werte:<br>\n            0 = Nein<br>\n            1 = Ja</i>",
                        "phone_marketing_confirmed_at": "Dieses Merkmal gibt ggf. an, wann die Zustimmung zum telefonischen Marketing gegeben wurde.<br>\n           <i>Werte:<br>\n            Eines der Formate in den Formatoptionen. Jeweils ggf. mit führender Null.<br>\n            TT = Tag<br>\n            MM = Monat<br>\n            JJJJ = Jahr<br>\n            SS = Stunde<br>\n            mm = Minute<br>\n            ss = Sekunde</i>",
                        "whatsapp_marketing_confirmed": "Dieses Merkmal gibt an, ob die Zustimmung zum WhatsApp-Marketing gegeben wurde.<br>\n           <i>Werte:<br>\n            0 = Nein<br>\n            1 = Ja</i>",
                        "whatsapp_marketing_confirmed_at": "Dieses Merkmal gibt ggf. an, wann die Zustimmung zum WhatsApp-Marketing gegeben wurde.<br>\n           <i>Werte:<br>\n            Eines der Formate in den Formatoptionen. Jeweils ggf. mit führender Null.<br>\n            TT = Tag<br>\n            MM = Monat<br>\n            JJJJ = Jahr<br>\n            SS = Stunde<br>\n            mm = Minute<br>\n            ss = Sekunde</i>",
                        "first_purchase_at": "Das Datum des ersten Einkaufs<br>\n            <i>Werte:<br>\n            Eines der Formate in den Formatoptionen. Jeweils ggf. mit führender Null.<br>\n            TT = Tag<br>\n            MM = Monat<br>\n            JJJJ = Jahr<br>\n            SS = Stunde<br>\n            mm = Minute<br>\n            ss = Sekunde</i>",
                        "reserved_for_digital_registration": "Dieses Merkmal gibt an, ob es sich um eine leere Kundenhülse für die digitale Neukundenregistrierung handelt.<br>\n           <i>Werte:<br>\n            0 = Nein<br>\n            1 = Ja</i>",
                        "reserved_for_paper_registration": "Dieses Merkmal gibt an, ob es sich um eine leere Kundenhülse für die Papier-Neukundenregistrierung handelt.<br>\n           <i>Werte:<br>\n            0 = Nein<br>\n            1 = Ja</i>",
                        "is_disabled": "Dieses Merkmal gibt an, ob der Kundendatensatz deaktiviert ist.<br>\n           <i>Werte:<br>\n            0 = Nein<br>\n            1 = Ja</i>",
                        "is_disabled_since": "Dieses Merkmal gibt ggf. an, wann der Kundendatensatz deaktiviert wurde.<br>\n            <i>Werte:<br>\n            Eines der Formate in den Formatoptionen. Jeweils ggf. mit führender Null.<br>\n            TT = Tag<br>\n            MM = Monat<br>\n            JJJJ = Jahr<br>\n            SS = Stunde<br>\n            mm = Minute<br>\n            ss = Sekunde</i>",
                        "is_disabled_reason": "Hier kann ein Grund für eine Deaktivierung angegeben werden<br>\n            <i>Werte:<br>\n            Beliebige Zeichen</i>",
                        "marketing_block_confirmed": "Dieses Merkmal gibt an, es eine generelle Werbesperre gibt.<br>\n           <i>Werte:<br>\n            0 = Nein<br>\n            1 = Ja</i>",
                        "marketing_block_confirmed_at": "Dieses Merkmal gibt ggf. an, wann die generelle Werbesperre erteilt wurde.<br>\n           <i>Werte:<br>\n            Eines der Formate in den Formatoptionen. Jeweils ggf. mit führender Null.<br>\n            TT = Tag<br>\n            MM = Monat<br>\n            JJJJ = Jahr<br>\n            SS = Stunde<br>\n            mm = Minute<br>\n            ss = Sekunde</i>",
                        "formatting_options": "Das Smart.KIS erwartet für einige Werte, bspw. Datumsangaben, ein bestimmtes Format. Liegen die Daten in einem anderen Format bei Ihnen vor, können Sie hier ggf. dieses einstellen.",
                        "smartkis_field": "Diese Spalte gibt an, welches Feld im Smart.KIS befüllt wird. Informationen zu deren Inhalt finden Sie in den Tooltips oder der Dokumentation.",
                        "user_field": "Geben sie hier an, welches Feld in ihrer Importdatei dem Smart.KIS-Feld entspricht.",
                        "default_value": "Ist eine Spalte als zu importieren markiert, das Feld in einem Datensatz allerdings leer, wird der hier angegebene Standardwert gesetzt.",
                        "import_empty": "Möchten Sie Daten mit leeren Werten überschreiben, bspw. um im Rahmen der DSGVO diese zu anonymisieren, dann wählen Sie diese Option."
                    },
                    "transactions": {
                        "customer_id": "Die eindeutige Kundennummer in Ihrer Warenwirtschaft. Die Zuordnung zu bestehenden Kundendaten basiert auf ihr.<br>\n            <i>Pflichtfeld - Werte:<br>\n            Beliebige Zeichen</i>",
                        "receipt_number": "Die Belegnummer des Bewegungsdatensatzes in Ihrer Warenwirtschaft. Die Zuordnung zu bestehenden Kundendaten basiert auch auf ihr.<br>\n            <i>Pflichtfeld - Werte:<br>\n            Beliebige Zeichen</i>",
                        "type": "Die Art der Bewegung. Die Zuordnung zu bestehenden Kundendaten basiert auch auf ihr.<br>\n            <i>Pflichtfeld - Werte:<br>\n            sale -> Verkauf<br>\n            refund -> Retoure\n            selection -> Auswahl</i>",
                        "sku": "Die Artikelnummer des Bewegungsdatensatzes. Die Zuordnung zu bestehenden Kundendaten basiert auch auf ihr.<br>\n            <i>Pflichtfeld - Werte:<br>\n            Beliebige Zeichen</i>",
                        "quantity": "Die Menge der verkauften Artikel. Die Zuordnung zu bestehenden Kundendaten basiert auch auf ihr.<br>\n            <i>Pflichtfeld - Werte:<br>\n            Ganzzahl</i>",
                        "foreign_guid": "Ein weiteres eindeutiges Kundenmerkmal. Es wird von einigen Warenwirtschaften mandantenübergreifend vergeben. <b>Bitte beachten Sie, dass es für die Zuordnung genutzt wird, wenn es belegt wurde.</b><br>\n            <i>Werte:<br>\n            Beliebige Zeichen</i>",
                        "store_id": "Die ID der Filiale. Sie bleibt nur erhalten wenn im Smart.KIS eine Filiale mit derselben ID existiert.<br>\n            <i>Werte:<br>\n            Ganzzahl</i>",
                        "store": "Der originale Name der Filiale aus ihrer Warenwirtschaft. Kann zu Rekonstruktionszwecken beim Export verwendet werden.<br>\n            <i>Werte:<br>\n            Beliebige Zeichen</i>",
                        "cash_register": "Die ID der Kasse.<br>\n            <i>Werte:<br>\n            Beliebige Zeichen</i>",
                        "employee_id": "Die ID des Verkaufspersonal. Sie bleibt nur erhalten, wenn im Smart.KIS Verkaufspersonal mit derselben ID existiert.<br>\n            <i>Werte:<br>\n            Ganzzahl</i>",
                        "seller": "Der originale Name des Verkaufspersonals aus ihrer Warenwirtschaft. Kann zu Rekonstruktionszwecken beim Export verwendet werden.<br>\n            <i>Werte:<br>\n            Beliebige Zeichen</i>",
                        "name": "Die Artikelbezeichnung.<br>\n            <i>Werte:<br>\n            Beliebige Zeichen</i>",
                        "name_supplemental": "Eine optionale, zusätzliche Artikelbezeichnung.<br>\n            <i>Werte:<br>\n            Beliebige Zeichen</i>",
                        "cost_price": "Der Nettoeinkaufspreis für eine Einheit.<br>\n            <i>Pflichtfeld - Werte:<br>\n            Gleitkommazahl</i>",
                        "cost_price_with_vat": "Der Bruttoeinkaufspreis für eine Einheit.<br>\n            <i>Pflichtfeld - Werte:<br>\n            Gleitkommazahl</i>",
                        "sales_price_1": "Der Nettoverkaufspreis für eine Einheit laut Etikett.<br>\n            <i>Pflichtfeld - Werte:<br>\n            Gleitkommazahl</i>",
                        "sales_price_1_with_vat": "Der Bruttoverkaufspreise für eine Einheit laut Etikett.<br>\n            <i>Pflichtfeld - Werte:<br>\n            Gleitkommazahl</i>",
                        "sales_price_2": "Der tatsächliche Nettoverkaufspreis für eine Einheit.<br>\n            <i>Pflichtfeld - Werte:<br>\n            Gleitkommazahl</i>",
                        "sales_price_2_with_vat": "Der tatsächliche Bruttoverkaufspreis für eine Einheit.<br>\n            <i>Pflichtfeld - Werte:<br>\n            Gleitkommazahl</i>",
                        "discount_price": "Der Rabatt (netto), der gewährt wurde.<br>\n            <i>Pflichtfeld - Werte:<br>\n            Gleitkommazahl</i>",
                        "discount_price_with_vat": "Der Bruttorabatt.<br>\n            <i>Pflichtfeld - Werte:<br>\n            Gleitkommazahl</i>",
                        "reduction_price": "Der Nachlass (netto), der gewährt wurde.<br>\n            <i>Pflichtfeld - Werte:<br>\n            Gleitkommazahl</i>",
                        "reduction_price_with_vat": "Der Bruttonachlass.<br>\n            <i>Pflichtfeld - Werte:<br>\n            Gleitkommazahl</i>",
                        "vat_percentage": "Der Mehrwertssteuersatz, der auf diesen Artikel anfällt.<br>\n            <i>Pflichtfeld - Werte:<br>\n            Ganzzahl</i>",
                        "department": "Die Abteilung, in der der Artikel ausgestellt wird.<br>\n            <i>Werte:<br>\n            Beliebige Zeichen</i>",
                        "supplier": "Der Lieferant des Artikels.<br>\n            <i>Werte:<br>\n            Beliebige Zeichen</i>",
                        "label": "Die Marke des Artikels.<br>\n            <i>Werte:<br>\n            Beliebige Zeichen</i>",
                        "product_group_1": "Die übergeordnete Hauptwarengruppe.<br>\n            <i>Werte:<br>\n            Beliebige Zeichen</i>",
                        "product_group_2": "Die Unterwarengruppe.<br>\n            <i>Werte:<br>\n            Beliebige Zeichen</i>",
                        "size": "Die Größe des Artikels. Kann in einer beliebigen Form wie etwa 'XL' oder '35' dargestellt werden.<br>\n            <i>Werte:<br>\n            Beliebige Zeichen</i>",
                        "goods_received_at": "Das Datum an dem der Artikel im Lager verzeichnet wurde.<br>\n            <i>Werte:<br>\n            Eines der Formate in den Formatoptionen. Jeweils ggf. mit führender Null.<br>\n            TT = Tag<br>\n            MM = Monat<br>\n            JJJJ = Jahr<br>\n            SS = Stunde<br>\n            mm = Minute<br>\n            ss = Sekunde</i>",
                        "sold_at": "Das Verkaufsdatum.<br>\n            <i>Werte:<br>\n            Eines der Formate in den Formatoptionen. Jeweils ggf. mit führender Null.<br>\n            TT = Tag<br>\n            MM = Monat<br>\n            JJJJ = Jahr<br>\n            SS = Stunde<br>\n            mm = Minute<br>\n            ss = Sekunde</i>",
                        "formatting_options": "Das Smart.KIS erwartet für einige Werte, bspw. Datumsangaben, ein bestimmtes Format. Liegen die Daten in einem anderen Format bei Ihnen vor, können Sie hier ggf. dieses einstellen.",
                        "smartkis_field": "Diese Spalte gibt an, welches Feld im Smart.KIS befüllt wird. Informationen zu deren Inhalt finden Sie in den Tooltips oder der Dokumentation.",
                        "user_field": "Geben sie hier an, welches Feld in Ihrer Importdatei dem Smart.KIS-Feld entspricht.",
                        "default_value": "Ist eine Spalte als zu importieren markiert, das Feld in einem Datensatz allerdings leer, wird der hier angegebene Standardwert gesetzt.",
                        "import_empty": "Möchten Sie Daten mit leeren Werten überschreiben, bspw. um im Rahmen der DSGVO diese zu anonymisieren, dann wählen Sie diese Option."
                    }
                },
                "please_check_data": "Bitte überprüfe nochmal die Daten",
                "filename": "Dateiname",
                "mapping": "Mapping",
                "client": "Kunde",
                "data_sets": "Datensätze",
                "are_you_sure": "Bist du dir sicher?",
                "cancel": "Abbrechen",
                "customer_import": "Kunden importieren"
            },
            "datainterfaces": {
                "datainterfaces": "Schnittstellen",
                "datainterface": "Schnittstelle",
                "new": "Neue Schnittstelle",
                "edit": "Schnittstelle bearbeiten",
                "save": "Schnittstelle speichern",
                "created": "Schnittstelle erstellt",
                "updated": "Schnittstelle aktualisiert",
                "deleted": "Schnittstelle gelöscht",
                "type": "Typ",
                "url": "URL",
                "username": "Benutzername",
                "password": "Passwort",
                "parameters": "Parameter",
                "is_active": "Aktiv",
                "types": {
                    "intelligix-customers": "Intelligix - Kundendaten",
                    "intelligix-customers-update": "Intelligix - Kundendaten aktualisieren",
                    "intelligix-transactions": "Intelligix - Bewegungsdaten",
                    "futura-customers": "Futura - Kundendaten",
                    "futura-customers-update": "Futura - Kundendaten aktualisieren",
                    "futura-transactions": "Futura - Bewegungsdaten",
                    "intersport-customers": "Intersport - Kundendaten",
                    "intersport-transactions": "Intersport - Bewegungsdaten",
                    "prohandel-customers": "ProHandel - Kundendaten",
                    "prohandel-transactions": "ProHandel - Bewegungsdaten",
                    "prohandel-api-customers": "ProHandel API 1.0 - Kundendaten",
                    "prohandel-api-customer-update": "ProHandel API 1.0 - Kundendaten aktualisieren",
                    "prohandel-api-transactions": "ProHandel API 1.0 - Bewegungsdaten",
                    "prohandel-api-v2-customers": "ProHandel API 2.0 - Kundendaten",
                    "prohandel-api-v2-customer-update": "ProHandel API 2.0 - Kundendaten aktualisieren",
                    "prohandel-api-v2-transactions": "ProHandel API 2.0 - Bewegungsdaten",
                    "prohandel-api-v2-transactions-fast": "ProHandel API 2.0 - Bewegungsdaten (Live)",
                    "hiltes-customers": "Hiltes - Kundendaten (komplette Importdatei)",
                    "hiltes-customers-extra": "Hiltes - Kundendaten (reduzierte Importdatei, nur Name und Kundennummer)",
                    "hiltes-transactions": "Hiltes - Bewegungsdaten",
                    "hiltes-customersv2": "Hiltes V2 - Kundendaten (komplette Importdatei)",
                    "hiltes-transactionsv2": "Hiltes V2 - Bewegungsdaten",
                    "sftp": "SFTP",
                    "advarics-customers": "Advarics API - Kundendaten",
                    "advarics-transactions": "Advarics API - Bewegungsdaten",
                    "advarics-employees": "Advarics API - Mitarbeiter",
                    "advarics-stores": "Advarics API - Filialen",
                    "advarics-customer-create": "Advarics API - Neuen Kunden anlegen",
                    "advarics-customer-update": "Advarics API - Kundendaten aktualisieren",
                    "smartkis-csv-customers": "Smart.KIS CSV Import - Kundendaten",
                    "smartkis-csv-transactions": "Smart.KIS CSV Import - Bewegungsdaten",
                    "smartkis-csv-customerexport-sftp": "Smart.KIS CSV Export - Kundendaten (mit SFTP-Upload)",
                    "smartkis-csv-customerexport-mail": "Kundendaten CSV Export 2.0 (Mailversand)",
                    "smartkis-csv-transactionexport-sftp": "Smart.KIS CSV Export - Bewegungsdaten (mit SFTP-Upload)",
                    "irics-csv-transactions": "IRICS CSV Import - Bewegungsdaten",
                    "standard-customer-import-v3": "Smart.KIS CSV Import V3 - Kundendaten",
                    "standard-transaction-import-v3": "Smart.KIS CSV Import V3 - Bewegungsdaten"
                }
            },
            "customers": {
                "customers": "Kunden",
                "customer": "Kunde ",
                "new": "Neuer Kunde",
                "edit": "Kunde bearbeiten",
                "save": "Kunde speichern",
                "created": "Kunde erstellt",
                "updated": "Kunde aktualisiert",
                "deleted": "Kunde gelöscht",
                "show": "Kunden anzeigen",
                "customer_identifier": "Kundennummer",
                "internal_customer_identifier": "Kundennummer (intern)",
                "card_number": "Kartennummer",
                "family_number": "Familiennummer",
                "name": "<tooltip classify_tooltip=\"test\">Name</tooltip>",
                "app_email": "E-Mail Adresse für App-Aktivierung/-Login",
                "email_marketing_confirmed": "E-Mail Marketing erlaubt",
                "confirmed_at": "Bestätigt am",
                "classic_marketing_confirmed": "Klassisches Marketing erlaubt",
                "app_marketing_confirmed": "App Marketing erlaubt",
                "phone_marketing_confirmed": "Telefonmarketing erlaubt",
                "whatsapp_marketing_confirmed": "WhatsApp Marketing erlaubt",
                "marketing_block_confirmed": "Werbesperre",
                "pin": "Aktivierungscode",
                "registration_number": "Kundennummer für Registrierung",
                "password": "Passwort",
                "uses_app": "Benutzt App",
                "uses_app_since": "Benutzt App seit",
                "number_of_logins": "Anzahl Logins",
                "last_login_at": "Letzter Login",
                "last_updated_at": "Letzte Aktualisierung durch Kunden",
                "hash": "Unique hash",
                "comment": "Kommentar",
                "created_at": "smart.KIS Erfassungsdatum",
                "kis_updated_at": "KIS Änderungsdatum",
                "last_data_exchange_at": "Letzte Aktualisierung aus KIS",
                "last_exported_at": "Letzter Export an Händler-KIS",
                "first_purchase_at": "Neukundenerfassungsdatum",
                "marketing_info": "Informationen zum Marketing",
                "app_info": "Informationen zur Appnutzung",
                "data_exchange_info": "Informationen zum Datenaustausch",
                "reset_registration": "Registrierung zurücksetzen",
                "reset_registration_question": "Soll die Registrierung für diesen Kunden wirklich zurückgesetzt werden?",
                "casual_customer": "Laufkunde",
                "is_employee": "Mitarbeiter",
                "has_digital_registration": "Digitaler Neukunde",
                "has_paper_registration": "Papier-Neukunde",
                "generate_transactions": "Testdaten generieren",
                "generate_transactions_question": "Testdaten für diesen Kunden generieren? (ACHTUNG: Alle vorhandenen Bewegungsdaten für diesen Kunden werden gelöscht!)",
                "transactions_generated": "Testdaten generiert",
                "additional_attributes": "Weitere Attribute",
                "registration_info": "Informationen zur Neukundenregistrierung",
                "reserved_for_digital_registration": "Reserviert für digitale Neukundenregistrierung",
                "reserved_for_digital_registration_short": "NKR-Hülse",
                "reserved_for_paper_registration": "Reserviert für Papier-Neukundenregistrierung",
                "reserved_for_registration": "Freie Kundennummern",
                "reserved_for_digital_registration_too_low": "Nicht genügend Kundennummern für die digitale Neukundenregistrierung verfügbar (Soll: {should}, Ist: {actually})",
                "reserved_for_paper_registration_too_low": "Nicht genügend Kundennummern für die Papier Neukundenregistrierung verfügbar (Soll: {should}, Ist: {actually})",
                "no_language_preference": "Keine Sprachauswahl getroffen",
                "push_release": "Push-Freigabe",
                "number_of_push_releases": "Anzahl Geräte mit Push-Freigabe",
                "language": "Sprache",
                "dear_salutations": {
                    "m": "Lieber Herr ",
                    "f": "Liebe Frau ",
                    "c": "Liebe Mitglieder der Firma ",
                    "h": "Liebe Familie ",
                    "n": "Liebe/r "
                },
                "disabled_info": "Informationen zur Deaktivierung",
                "is_disabled": "Kunde ist deaktiviert",
                "is_disabled_since": "Seit",
                "is_disabled_reason": "Begründung",
                "test_user_info": "Einstellungen für Testbenutzer",
                "is_test_user": "Testbenutzer",
                "import": {
                    "log_success": "Import erfolgreich. Neue Kunden: {created}, aktualisierte Kunden: {updated}",
                    "import": "Kunden importieren",
                    "file": "Importdatei",
                    "format_incorrect": "Ungültiges Importformat. Die Spalten aus der Importdatei entsprechen nicht den geforderten.",
                    "no_client": "Keine Händlernummer in Zeile {row}",
                    "no_customer": "Kunde {customer_identifier} in Zeile {row} nicht gefunden",
                    "no_content": "Import-Datei enthält keine zu importierenden Daten",
                    "wrong_client": "Falsche Händlernummer {client_number} in Zeile {row}",
                    "created": "Kunde {customer_identifier} wurde erstellt",
                    "updated": "Kunde {customer_identifier} wurde aktualisiert",
                    "disabled": "Kunde {customer_identifier} wurde DEAKTIVIERT",
                    "enabled": "Kunde {customer_identifier} wurde AKTIVIERT",
                    "flagged_for_digital_registration": "Kundennummer {customer_identifier} wurde für DIGITALE REGISTRIERUNG markiert",
                    "flagged_for_paper_registration": "Kundennummer {customer_identifier} wurde für PAPIERREGISTRIERUNG markiert",
                    "not_flagged_for_digital_registration": "Kundennummer {customer_identifier} konnte NICHT markiert werden",
                    "not_flagged_for_paper_registration": "Kundennummer {customer_identifier} konnte NICHT markiert werden",
                    "import_data_too_old": "Zu importierende Daten für Kunde {customer_identifier} sind älter als die vorliegenden Daten (Zeile {row})",
                    "registration": "Freie Kundennummern markieren",
                    "registration_type": "Art der Neukundenregistrierung",
                    "registration_types": {
                        "digital": "Digital",
                        "paper": "Papier"
                    },
                    "mark_with_file": "Über Datei markieren",
                    "mark_with_range": "Über Nummernkreise markieren",
                    "mark": "Kunden markieren",
                    "mail_mark_success": "Die Markierung der Kundennummern ist abgeschlossen.",
                    "mail_mark_failed": "Es gab Fehler bei der Markierung der Kundennummern",
                    "mail_mark_subject": "Markierung von Kundennummern für ",
                    "file_info": "Es wird eine CSV Datei mit einer Spalte für die Kundennummern ohne Überschrift erwartet.",
                    "please_enter_range": "Bitte geben Sie einen Nummernkreis an!",
                    "success": "Der Import wurde erfolgreich gestartet. Sie erhalten eine E-Mail an folgende Adresse wenn der Import beendet ist: ",
                    "failure": "Der Import konnte nicht gestartet werden. Bitte stellen Sie sicher, dass die Datei im CSV Format hochgeladen worden ist"
                },
                "export": {
                    "download_definitions": "Download Hiltes-Export Spaltenbeschreibungen",
                    "export": "Kunden exportieren",
                    "type": "Typ",
                    "types": {
                        "csv": "CSV",
                        "xls": "Excel"
                    },
                    "header": "Spaltenüberschriften",
                    "headers": {
                        "translated": "Übersetzt",
                        "plain": "Original (Namen der Datenbankfelder)"
                    },
                    "timeframe": "Zeitraum",
                    "timeframes": {
                        "individual": "Änderungen ab einem bestimmten Datum",
                        "full": "Komplett"
                    },
                    "since": "Seit",
                    "exporters": {
                        "standard-customer-export-v2": "Standard Stammdaten Exporter 2.0",
                        "hiltes-customer-export": "Hiltes Stammdaten Exporter 2.0"
                    },
                    "success": "Der Export wurde erfolgreich gestartet. Sie erhalten eine E-Mail an folgende Adresse wenn der Export beendet ist: ",
                    "unsuccessful": "Der Export konnte aufgrund technischer Probleme NICHT gestartet werden.",
                    "unknown_error": "Es ist ein nicht dokumentierter Fehler aufgetreten!",
                    "no_customers": "Es wurden keine Kunden für einen Export gefunden!"
                },
                "login_info": "Informationen zum Login",
                "contact_info": "Kontaktdaten",
                "address_info": "Adressdaten",
                "street_number": "Hausnummer",
                "customer_identifier_and_card_number": "<tooltip>Kunden- / Kartennummer</tooltip>",
                "selectionCache": {
                    "nationality": {
                        "not_available": "keine Nationalität erfasst"
                    }
                }
            },
            "invoices": {
                "invoices": "Abrechnungstabellen",
                "invoice": "Abrechnungstabelle vom ",
                "no_invoices": "Es gibt momentan keine Abrechungstabellen zur Auswahl. Diese werden jeweils am Monatsende erstellt.",
                "download": "Abrechungstabelle herunterladen",
                "choose": "Monat für die Abrechnung wählen:",
                "no_campaign_customers": "Keine Kampagnen-Aussendungen",
                "no_campaign_customer_notifications": "Keine Pushaussendungen",
                "exported": "Abrechnungstabelle erfolgreich exportiert",
                "error": "Es gab einen Fehler beim Download der Abrechnungstabelle"
            },
            "groups": {
                "groupname": "Gruppenname",
                "groups": "Chatgruppen",
                "group": "Chatgruppe",
                "new": "Erstelle Gruppe",
                "edit": "Editiere Gruppe",
                "save": "Speichere Gruppe",
                "created": "Gruppe wurde erstellt",
                "updated": "Gruppe wurde aktualisiert",
                "deleted": "Gruppe wurde gelöscht",
                "name": "Name"
            },
            "tooltips": {
                "monitoring": {
                    "TDP": "Der Teile-Durschnitts-Preis (TDP) bezieht sich auf einen Einkaufstag (nicht Einkaufsbon) pro Kunde.",
                    "TDA": "Die Teile-Durschnitts-Anzahl (TDA) bezieht sich auf einen Einkaufstag (nicht Einkaufsbon) pro Kunde.",
                    "DurchschnittsTag": "Der Durschnittstag bezieht sich auf alle Einkäufe, die ein Kunde an einem Tag getätigt hat. Unabhängig von der Anzahl der Kassenbons.",
                    "KF": "Die Kauf-Frequenz (KF) gibt an, wie oft ein Kunde dieser Kundengruppe im Schnitt im ausgewählten Zeitraum einen Kauf tätigt.",
                    "KWG": "Die Kauf-Wiederkehr-Geschwindigkeit (KWG) gibt in Tagen an, welcher Zeitraum im Schnitt zwischen den Käufen eines Kunden dieser Kundengruppe liegt.",
                    "appUser": "Anzahl der Kunden, die sich für die Kunden-App registriert haben",
                    "appUserIn": "in % zu Spalte Anzahl (Kundenanzahl in Berechnungszeitraum)"
                },
                "selections": {
                    "view_type": "Verknüpfungstypen (und - oder - und nicht) beziehen sich nur auf Bewegungsdatenabfragen. Stammdatenabfragen haben immer den Verknüpfungstyp \"und\"."
                }
            },
            "v3_campaign_customer_notifications": {
                "campaign_customer_notifications": "Nachrichten-Aussendungen",
                "campaign_customer_notification": "Nachricht-Aussendung",
                "new": "Neue Nachrichten-Aussendung",
                "edit": "Nachrichten-Aussendung bearbeiten",
                "save": "Nachrichten-Aussendung speichern",
                "created": "Nachrichten-Aussendung erstellt",
                "updated": "Nachrichten-Aussendung aktualisiert",
                "deleted": "Nachrichten-Aussendung gelöscht",
                "is_sent": "Nachricht verschickt",
                "sent_at": "Am",
                "push_notification_id": "Nachrichten-ID im Push-Nachrichten-Service",
                "push_notification_error": "Antwort vom Push-Nachrichten-Service",
                "embargo_until": "Nachrichten-Versandzeitpunkt",
                "allnotificationsforcustomers": "alle Aussendungen anzeigen (letzte 36 Monate)",
                "import": {
                    "import": "Nachrichten-Aussendungen importieren",
                    "file": "Importdatei",
                    "format_incorrect": "Ungültiges Importformat",
                    "wrong_campaign_notification": "Falsche Nachrichten ID {campaign_notification_id} in Zeile {row}",
                    "no_customer": "Ungültige Kundennummer {customer_identifier} in Zeile {row}",
                    "customer_does_not_use_app": "Kein App-Benutzer {customer_identifier} in Zeile {row}",
                    "created": "Nachrichten-Aussendung für {customer_identifier} wurde erstellt",
                    "updated": "Nachrichten-Aussendung für {customer_identifier} wurde aktualisiert",
                    "import_data_too_old": "Zu importierende Daten für Kunde {customer_identifier} sind älter als die vorliegenden Daten (Zeile {row})",
                    "campaign_customer_missing": "Es existiert keine Kampagnen-Aussendung für die Kundennummer {customer_identifier}"
                }
            }
        },
        "http_errors": {
            "404": {
                "title": "404: Diese Seite konnten wir nicht finden!",
                "description": "Falls die Adresse korrekt ist und Sie sich sicher sind, dass es sich hierbei um einen Fehler handelt, wenden Sie sich bitte an den Support unter <a href=\"http://kunden-app.com/support/\">http://kunden-app.com/support/</a>"
            },
            "503": {
                "title": "503: Wartungsarbeiten",
                "description": "Wir sind in Kürze wieder für Sie da."
            },
            "500": {
                "title": "500: Interner Serverfehler",
                "description": "Bleibt das Problem bestehen, wenden Sie sich bitte an den Support unter <a href=\"http://kunden-app.com/support/\">http://kunden-app.com/support/</a>"
            },
            "502": {
                "title": "502: Die Anfrage hat zu Lange gedauert",
                "description": "Der Server hat es nicht geschafft, eine Antwort zu senden. Womöglich ist er im Moment überlastet, bitte versuchen Sie es später erneut. Prüfen Sie bitte, ob die von Ihnen gewünschte Aktion (bspw. Abspeichern oder Aussenden) trotzdem durchgeführt wurde oder noch durchgeführt wird, bevor Sie es erneut versuchen. Dies ist häufig der Fall. Bleibt das Problem bestehen, wenden Sie sich bitte an den Support unter <a href=\"http://kunden-app.com/support/\">http://kunden-app.com/support/</a>"
            }
        },
        "validation": {
            "accepted": "{attribute} muss akzeptiert werden.",
            "active_url": "{attribute} ist keine gültige Internet-Adresse.",
            "after": "{attribute} muss ein Datum nach dem {date} sein.",
            "alpha": "{attribute} darf nur aus Buchstaben bestehen.",
            "alpha_dash": "{attribute} darf nur aus Buchstaben, Zahlen, Binde- und Unterstrichen bestehen. Umlaute (ä, ö, ü) und Eszett (ß) sind nicht erlaubt.",
            "alpha_num": "{attribute} darf nur aus Buchstaben und Zahlen bestehen.",
            "array": "{attribute} muss ein Array sein.",
            "before": "{attribute} muss ein Datum vor dem {date} sein.",
            "between": {
                "numeric": "{attribute} muss zwischen {min} & {max} liegen.",
                "file": "{attribute} muss zwischen {min} & {max} Kilobytes groß sein.",
                "string": "{attribute} muss zwischen {min} & {max} Zeichen lang sein.",
                "array": "{attribute} muss zwischen {min} & {max} Elemente haben."
            },
            "dimensions": "Die Bildgröße muss zwischen den Maßen {max_width} x {max_height} und {min_width} x {min_height} liegen",
            "boolean": "{attribute} muss entweder 'true' oder 'false' sein.",
            "confirmed": "{attribute} stimmt nicht mit der Bestätigung überein.",
            "date": "{attribute} muss ein gültiges Datum sein.",
            "date_format": "{attribute} entspricht nicht dem gültigen Format für {format}.",
            "different": "{attribute} und {other} müssen sich unterscheiden.",
            "digits": "{attribute} muss {digits} Stellen haben.",
            "digits_between": "{attribute} muss zwischen {min} und {max} Stellen haben.",
            "distinct": "The {attribute} field has a duplicate value.",
            "email": "{attribute} Format ist ungültig.",
            "exists": "Der gewählte Wert für {attribute} ist ungültig.",
            "filled": "{attribute} muss ausgefüllt sein.",
            "image": "{attribute} muss ein Bild sein.",
            "in": "Der gewählte Wert für {attribute} ist ungültig.",
            "in_array": "The {attribute} field does not exist in {other}.",
            "integer": "{attribute} muss eine ganze Zahl sein.",
            "ip": "{attribute} muss eine gültige IP-Adresse sein.",
            "json": "{attribute} muss ein gültiger JSON-String sein.",
            "max": {
                "numeric": "{attribute} darf maximal {max} sein.",
                "file": "{attribute} darf maximal {max} Kilobytes groß sein.",
                "string": "{attribute} darf maximal {max} Zeichen haben.",
                "array": "{attribute} darf nicht mehr als {max} Elemente haben."
            },
            "mimes": "{attribute} muss den Dateityp {values} haben.",
            "min": {
                "numeric": "{attribute} muss mindestens {min} sein.",
                "file": "{attribute} muss mindestens {min} Kilobytes groß sein.",
                "string": "{attribute} muss mindestens {min} Zeichen lang sein.",
                "array": "{attribute} muss mindestens {min} Elemente haben."
            },
            "not_in": "Der gewählte Wert für {attribute} ist ungültig.",
            "numeric": "{attribute} muss eine Zahl sein.",
            "present": "The {attribute} field must be present.",
            "regex": "{attribute} Format ist ungültig.",
            "required": "{attribute} muss ausgefüllt sein.",
            "required_if": "{attribute} muss ausgefüllt sein.",
            "required_unless": "{attribute} muss ausgefüllt sein, wenn {other} nicht {values} ist.",
            "required_with": "{attribute} muss angegeben werden, wenn {values} ausgefüllt wurde.",
            "required_with_all": "{attribute} muss angegeben werden, wenn {values} ausgefüllt wurde.",
            "required_without": "{attribute} muss angegeben werden, wenn {values} nicht ausgefüllt wurde.",
            "required_without_all": "{attribute} muss angegeben werden, wenn keines der Felder {values} ausgefüllt wurde.",
            "same": "{attribute} und {other} müssen übereinstimmen.",
            "size": {
                "numeric": "{attribute} muss gleich {size} sein.",
                "file": "{attribute} muss {size} Kilobyte groß sein.",
                "string": "{attribute} muss {size} Zeichen lang sein.",
                "array": "{attribute} muss genau {size} Elemente haben."
            },
            "string": "{attribute} muss ein String sein.",
            "timezone": "{attribute} muss eine gültige Zeitzone sein.",
            "unique": "{attribute} ist schon vergeben.",
            "url": "Das Format von {attribute} ist ungültig.",
            "extension": "Falsches Format der hochgeladenen Datei ({extension} anstatt {should}).",
            "gt": {
                "numeric": "{attribute} muss größer als {value} sein."
            },
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                }
            },
            "attributes": [],
            "check_doubles": "Mit den von Ihnen eingegebenen Daten ist eine Registrierung nicht möglich - bitte wenden Sie sich an unser Verkaufspersonal."
        },
        "general": {
            "not_defined": "nicht definiert",
            "data_are_loading": "Daten werden geladen",
            "data_loading_unsuccessful": "Daten konnten aus technischen Gründen nicht geladen werden. Bitte versuchen Sie es zu einem späteren Zeitpunkt nochmals.",
            "days": "Tage",
            "close": "schließen",
            "yes": "ja",
            "no": "nein"
        }
    },
    "en": {
        "passwords": {
            "password": "Passwords must be at least six characters and match the confirmation.",
            "reset": "Your password has been reset!",
            "sent": "We have e-mailed your password reset link!",
            "token": "This password reset token is invalid.",
            "user": "We can't find a user with that e-mail address."
        },
        "auth": {
            "failed": "These credentials do not match our records.",
            "throttle": "Too many login attempts. Please try again in {seconds} seconds."
        },
        "pagination": {
            "previous": "&laquo; Previous",
            "next": "Next &raquo;"
        },
        "backend": {
            "campaign_customers": {
                "campaign_customers": "Campaign customers",
                "campaign_customer": "Campaign customer",
                "new": "Create campaign customer",
                "edit": "Edit campaign customer",
                "save": "Save campaign customer",
                "is_redeemed": "Redeemed",
                "value": "Value",
                "code": "Coupon code",
                "redeemed_at": "Redeemed at",
                "expires_at": "Expires_at",
                "allcampaignsforcustomers": "all campaigns (last 36 month)",
                "actualcampaignsforcustomers": "actual campaigns",
                "current_number": "curr.nr."
            },
            "employees": {
                "employees": "Employees",
                "employee": "Employee",
                "new": "Create employee",
                "edit": "Edit employee",
                "save": "Save employee"
            },
            "campaigns": {
                "campaigns": "Campaigns",
                "campaign": "Campaign",
                "new": "Create campaign",
                "edit": "Edit campaign",
                "save": "Save campaign",
                "type": "Type",
                "subline": "Subline",
                "value": "Value",
                "minimum_value": "Mininum value",
                "store": "Stores",
                "description_1": "Description 1",
                "description_2": "Description 2",
                "description_3": "Description 3",
                "description_4": "Description 4",
                "description_5": "Description 5",
                "teaser_image": "Teaser image",
                "body_image": "Body image",
                "types": {
                    "bonus_voucher": "Bonus voucher",
                    "coupon_euro": "Coupon with value (selected currency)",
                    "coupon_percent": "Coupon with percent value",
                    "give_away": "Giveaway",
                    "invitation": "Invitation",
                    "coupon_backwards": "Backwards Coupon"
                },
                "code_types": {
                    "no_code": "No code",
                    "static_code": "Static code",
                    "static_code_with_image": "Static code with QR or barcode",
                    "individual_code_with_image": "Individual code with QR or barcode"
                },
                "code_type": "Code type",
                "code": "Static code",
                "link": "Link",
                "google_analytics_campaign_code": "Google Analytics campaign code",
                "starts_at": "Start date",
                "ends_at": "End date",
                "is_at": "Campaign date",
                "campaign_info": "Campaign information",
                "additional_info": "Additional information"
            },
            "smartkis": {
                "smartkis": "smart.KIS"
            },
            "qr_campaigns": {
                "qr_campaigns": "Qr campaigns",
                "qr_campaign": "Qr campaign",
                "new": "Create qr campaign",
                "edit": "Edit qr campaign",
                "save": "Save qr campaign",
                "created": "Qr campaign created",
                "updated": "Qr campaign updated",
                "deleted": "Qr campaign deleted",
                "name": "Name"
            },
            "campaign_notifications": {
                "campaign_notifications": "Campaign notifications",
                "campaign_notification": "Campaign notification",
                "new": "Create campaign notification",
                "edit": "Edit campaign notification",
                "save": "Save campaign notification",
                "created": "Campaign notification created",
                "updated": "Campaign notification updated",
                "deleted": "Campaign notification deleted",
                "name": "Name"
            },
            "transactions": {
                "transactions": "Transactions",
                "transaction": "Transaction",
                "new": "Create transaction",
                "edit": "Edit transaction",
                "save": "Save transaction",
                "types": {
                    "sale": "Sale",
                    "refund": "Refund",
                    "selection": "Selection"
                },
                "receipt_number": "Receipt number",
                "sold_at": "Sold at",
                "type": "Transaction type",
                "department": "Department",
                "cash_register": "Cash register",
                "seller": "Seller",
                "sku": "Article SKU",
                "name": "Name",
                "name_supplemental": "Name (continued)",
                "quantity": "Quantity",
                "supplier": "Supplier",
                "label": "Label",
                "product_group_1": "Product group",
                "product_group_2": "Sub product group",
                "size": "Size",
                "goods_received_at": "Goods received at",
                "vat_percentage": "VAT percentage",
                "cost_price": "Cost price",
                "cost_price_with_vat": "Cost price (with VAT)",
                "sales_price_1": "Sales price before reductions",
                "sales_price_1_with_vat": "Sales price before reductions (with VAT)",
                "sales_price_2": "Sales price after reductions",
                "sales_price_2_with_vat": "Sales price after reductions (with VAT)",
                "discount_price": "Discount price",
                "discount_price_with_vat": "Discount price (with VAT)",
                "reduction_price": "Reduction price",
                "reduction_price_with_vat": "Reduction price (with VAT)",
                "article_info": "Article information",
                "price_info": "Price information"
            },
            "message-templates": {
                "message_templates": "Message templates",
                "message_template": "Message template",
                "new": "Create message template",
                "edit": "Edit message template",
                "save": "Save message template",
                "created": "Message template created",
                "updated": "Message template updated",
                "deleted": "Message template deleted",
                "name": "Name"
            },
            "apps": {
                "apps": "Apps",
                "app": "App",
                "new": "Create app",
                "edit": "Edit app",
                "save": "Save app",
                "created": "App created",
                "updated": "App updated",
                "deleted": "App deleted",
                "name": "Name"
            },
            "stores": {
                "stores": "Stores",
                "store": "Store",
                "new": "Create store",
                "edit": "Edit store",
                "save": "Save store"
            },
            "guestlists": {
                "guestlists": "Guestlists",
                "guestlist": "Guestlist",
                "new": "Create guestlist",
                "edit": "Edit guestlist",
                "save": "Save guestlist",
                "created": "Guestlist created",
                "updated": "Guestlist updated",
                "deleted": "Guestlist deleted",
                "name": "Name"
            },
            "monitoring_groups": {
                "monitoring_groups": "Monitoring groups",
                "monitoring_group": "Monitoring group",
                "new": "Create monitoring group",
                "edit": "Edit monitoring group",
                "save": "Save monitoring group",
                "created": "monitoring group is created",
                "updated": "monitoring group is updated",
                "deleted": "monitoring group is deleted",
                "name": "name",
                "minimum_value": "sale >=",
                "maximum_value": "sale <",
                "color": "color",
                "number_groups": "range of numbers (z.B. 1-99,201-299)",
                "number_groups_without_brackets": "range of numbers",
                "exclude_from_all_friends": "excluded from all monitoring groups involving \"All Friends\"",
                "expand": "show overview anzeigen",
                "new_friends": "New Friends",
                "all_friends": "All Friends",
                "casual_customers": "casual customers"
            },
            "devices": {
                "devices": "Devices",
                "device": "Device",
                "new": "Create device",
                "edit": "Edit device",
                "save": "Save device"
            },
            "consultants": {
                "consultants": "Consultants",
                "consultant": "Consultant",
                "new": "Create consultant",
                "edit": "Edit consultant",
                "save": "Save consultant"
            },
            "selection_results": {
                "selection_results": "Selection results",
                "selection_result": "Selection result",
                "new": "Create selection result",
                "edit": "Edit selection result",
                "save": "Save selection result",
                "created": "Selection result created",
                "updated": "Selection result updated",
                "deleted": "Selection result deleted",
                "name": "Name"
            },
            "monitoring": {
                "monitoring": "monitoring",
                "basic_monitoring": "monitoring",
                "new_friends_monitoring": "development new customers",
                "new_friends_interval_start": "new customers - period of time - beginning",
                "new_friends_interval_end": "new customers - period of time - ending",
                "interval_start": "period of time - beginning",
                "interval_end": "period of time - ending",
                "campaign_interval": "use period of time from campaign",
                "campaign_interval_start": "campaings period of time - beginning",
                "campaign_interval_end": "campaigns period of time - ending",
                "campaign_comparison_interval_start": "comparison period of time - beginning",
                "campaign_comparison_interval_end": "comparison period of time - ending",
                "interval": "time section",
                "submit": "show",
                "intervals": {
                    "year": "year",
                    "month": "month",
                    "week": "week",
                    "two_week": "two weeks",
                    "day": "day"
                },
                "geomarketing": "geomarketing",
                "tabs": {
                    "options": "options for analysis",
                    "cockpit": "cockpit",
                    "customers": "customers",
                    "sales": "sale",
                    "writeoff": "writeoff",
                    "numberofsales": "number of purchases",
                    "salesvaluepersale": "sale per purchase",
                    "appstats": "devices and e-mail-addresses",
                    "temperatureprecipation": "weather",
                    "top_brands": "top-brands",
                    "top_product_groups": "top-product-groups",
                    "top_customers": "top-customers",
                    "top_zip": "top-zips"
                },
                "type": "type",
                "types": {
                    "basic": "normal",
                    "comparison_years": "yearly comparisons",
                    "comparison_stores": "comparison of branches",
                    "campaigns": "campaigns"
                },
                "comparison_years": "years",
                "comparison_stores": "branches",
                "campaigns": "campaigns",
                "comparison_stores_year": "year",
                "one_year_back": "one year back",
                "two_years_back": "two years back",
                "three_years_back": "three years back",
                "all_stores": "overarching branches",
                "enlarge_chart": "increase",
                "monitoring_options": "options for analysis",
                "temperature": "temperature",
                "precipation": "precipation",
                "sales_between_calculation_no_minimum": "sale < {maximum_value} {currency_symbol}",
                "sales_between_calculation_no_maximum": "sale >= {minimum_value} {currency_symbol}",
                "sales_between_calculation": "sale >= {minimum_value} {currency_symbol} and < {maximum_value} {currency_symbol}",
                "new_friends_calculation": "sale >= 1 {currency_symbol} and first purchase within period of time",
                "definitions": "definitions",
                "defined_for_this_evaluation": "chosen parmameters for this monitoring",
                "set_definitions": "determine definitions",
                "table": "table view",
                "pie": "pie chart",
                "bar": "bar chart",
                "sales": "sales",
                "devices": "new device / Push-Freigaben",
                "emailconfirmations": "confirmed e-mail-addresses",
                "salesvalueperreceipt": "average sale per purchase",
                "salesvalueperday": "average sale per day",
                "customers": "number of customers",
                "numberofsales": "sales",
                "sales_vs_margin": "sale vs. achieved margin (gross/net)",
                "netrevenue": "gross profit (gross/net)",
                "margin": "archieved margin (gross/net)",
                "writeoff": "writeoff",
                "writeoff_percentage": "writeoff percentage",
                "temperatureprecipation": "temperature and precipation",
                "kis_and_new_friends": "KIS / new customer quote",
                "no_comparison_data_available": "no comparison-data available",
                "headlines": {
                    "ranking": "Ranking",
                    "nation": "nation",
                    "name": "name",
                    "postal_code": "zip",
                    "city": "city",
                    "sale": "sale",
                    "number_of_customers": "number of customers",
                    "customers": "customers",
                    "brand": "branch",
                    "product_group": "product group",
                    "period_of_time": "period of time",
                    "in": "in"
                }
            },
            "client_profiles": {
                "project_info": "Project information",
                "client_number": "Client number",
                "opt_in_email_template": "Email template for opt-in",
                "password_forgotten_email_template": "Email template for password forgotten",
                "code_type": "Code type",
                "code_types": {
                    "qr": "QR code",
                    "bar": "Barcode"
                },
                "api_token": "API token"
            },
            "monitoring_archives": {
                "monitoring_archives": "Monitoring archives",
                "monitoring_archive": "Monitoring archive",
                "new": "Create monitoring archive",
                "edit": "Edit monitoring archive",
                "save": "Save monitoring archive",
                "created": "Monitoring archive created",
                "updated": "Monitoring archive updated",
                "deleted": "Monitoring archive deleted",
                "name": "Name"
            },
            "campaign_customer_notifications": {
                "campaign_customer_notifications": "Campaign customer notifications",
                "campaign_customer_notification": "Campaign customer notification",
                "new": "Create campaign customer notification",
                "edit": "Edit campaign customer notification",
                "save": "Save campaign customer notification",
                "created": "Campaign customer notification created",
                "updated": "Campaign customer notification updated",
                "deleted": "Campaign customer notification deleted",
                "name": "Name",
                "allcampaignsforcustomers": "all campaigns for the last 36 month"
            },
            "selections": {
                "selections": "Selections",
                "selection": "Selection",
                "new": "Create selection",
                "edit": "Edit selection",
                "save": "Save selection",
                "created": "Selection created",
                "updated": "Selection updated",
                "deleted": "Selection deleted",
                "name": "Name"
            },
            "datainterfaces": {
                "datainterfaces": "Datainterfaces",
                "datainterface": "Datainterface",
                "new": "Create datainterface",
                "edit": "Edit datainterface",
                "save": "Save datainterface"
            },
            "customers": {
                "customers": "Customers",
                "customer": "Customer",
                "new": "Create customer",
                "edit": "Edit customer",
                "save": "Save customer",
                "customer_identifier": "Customer identifier",
                "card_number": "Card number",
                "family_number": "Family number",
                "name": "Name",
                "email_marketing_confirmed": "Email marketing confirmed",
                "confirmed_at": "Confirmed on",
                "classic_marketing_confirmed": "Classic marketing confirmed",
                "app_marketing_confirmed": "App marketing confirmed",
                "phone_marketing_confirmed": "Phone marketing confirmed",
                "whatsapp_marketing_confirmed": "Whatsapp marketing confirmed",
                "marketing_block_confirmed": "Marketing block confirmed",
                "pin": "PIN",
                "password": "Password",
                "uses_app": "App user",
                "number_of_logins": "Number of logins",
                "last_login_at": "Last login",
                "comment": "Comment",
                "created_at": "Added to smart.KIS",
                "kis_updated_at": "Last change in KIS",
                "last_data_exchange_at": "Last updated from KIS",
                "last_updated_at": "Last updated by customer",
                "first_purchase_at": "Customer since",
                "hash": "Unique hash",
                "allow_email_marketing": "E-Mail Marketing erlauben",
                "disallow_email_marketing": "E-Mail Marketing nicht erlauben",
                "allow_email_marketing_question": "E-Mail Marketing für diesen Kunden wirklich erlauben?",
                "disallow_email_marketing_question": "Erlaubnis zum E-Mail Marketing für diesen Kunden entziehen?",
                "marketing_info": "Marketing specific settings",
                "app_info": "App specific settings",
                "data_exchange_info": "Data exchange",
                "import": {
                    "import": "Import customers",
                    "file": "Import file (CSV)",
                    "format_incorrect": "Invalid format. Columns in Excel file are not the needed ones.",
                    "no_client": "No client number in row {row}",
                    "wrong_client": "Wrong client number {client_number} in row {row}",
                    "created": "Customer {customer_identifier} created",
                    "updated": "Customer {customer_identifier} updated",
                    "import_data_too_old": "Data to be imported for customer {customer_identifier} is older than the currently saved data (row {row})",
                    "no_content": "import-file contents no importable data"
                },
                "export": {
                    "export": "Export customers"
                }
            },
            "groups": {
                "groups": "Groups",
                "group": "Group",
                "new": "Create group",
                "edit": "Edit group",
                "save": "Save group",
                "created": "Group created",
                "updated": "Group updated",
                "deleted": "Group deleted",
                "name": "Name"
            }
        },
        "validation": {
            "accepted": "The {attribute} must be accepted.",
            "active_url": "The {attribute} is not a valid URL.",
            "after": "The {attribute} must be a date after {date}.",
            "alpha": "The {attribute} may only contain letters.",
            "alpha_dash": "The {attribute} may only contain letters, numbers, and dashes.",
            "alpha_num": "The {attribute} may only contain letters and numbers.",
            "array": "The {attribute} must be an array.",
            "before": "The {attribute} must be a date before {date}.",
            "between": {
                "numeric": "The {attribute} must be between {min} and {max}.",
                "file": "The {attribute} must be between {min} and {max} kilobytes.",
                "string": "The {attribute} must be between {min} and {max} characters.",
                "array": "The {attribute} must have between {min} and {max} items."
            },
            "boolean": "The {attribute} field must be true or false.",
            "confirmed": "The {attribute} confirmation does not match.",
            "date": "The {attribute} is not a valid date.",
            "date_format": "The {attribute} does not match the format {format}.",
            "different": "The {attribute} and {other} must be different.",
            "digits": "The {attribute} must be {digits} digits.",
            "digits_between": "The {attribute} must be between {min} and {max} digits.",
            "distinct": "The {attribute} field has a duplicate value.",
            "email": "The {attribute} must be a valid email address.",
            "exists": "The selected {attribute} is invalid.",
            "filled": "The {attribute} field is required.",
            "image": "The {attribute} must be an image.",
            "in": "The selected {attribute} is invalid.",
            "in_array": "The {attribute} field does not exist in {other}.",
            "integer": "The {attribute} must be an integer.",
            "ip": "The {attribute} must be a valid IP address.",
            "json": "The {attribute} must be a valid JSON string.",
            "max": {
                "numeric": "The {attribute} may not be greater than {max}.",
                "file": "The {attribute} may not be greater than {max} kilobytes.",
                "string": "The {attribute} may not be greater than {max} characters.",
                "array": "The {attribute} may not have more than {max} items."
            },
            "mimes": "The {attribute} must be a file of type: {values}.",
            "min": {
                "numeric": "The {attribute} must be at least {min}.",
                "file": "The {attribute} must be at least {min} kilobytes.",
                "string": "The {attribute} must be at least {min} characters.",
                "array": "The {attribute} must have at least {min} items."
            },
            "not_in": "The selected {attribute} is invalid.",
            "numeric": "The {attribute} must be a number.",
            "present": "The {attribute} field must be present.",
            "regex": "The {attribute} format is invalid.",
            "required": "The {attribute} field is required.",
            "required_if": "The {attribute} field is required when {other} is {value}.",
            "required_unless": "The {attribute} field is required unless {other} is in {values}.",
            "required_with": "The {attribute} field is required when {values} is present.",
            "required_with_all": "The {attribute} field is required when {values} is present.",
            "required_without": "The {attribute} field is required when {values} is not present.",
            "required_without_all": "The {attribute} field is required when none of {values} are present.",
            "same": "The {attribute} and {other} must match.",
            "size": {
                "numeric": "The {attribute} must be {size}.",
                "file": "The {attribute} must be {size} kilobytes.",
                "string": "The {attribute} must be {size} characters.",
                "array": "The {attribute} must contain {size} items."
            },
            "string": "The {attribute} must be a string.",
            "timezone": "The {attribute} must be a valid zone.",
            "unique": "The {attribute} has already been taken.",
            "url": "The {attribute} format is invalid.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                }
            },
            "attributes": []
        }
    }
}
